<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-content class="ask-subject" :style="{padding: '9px'}" v-bind:class="{'request-status-bar': this.selectedOwner}">
				<div class="card-inline ask-status-bar" >
					<div>
						<p v-text="getStatus" class="ask-status"></p>
						<span v-if="ask.favorite">
							<button type="button" class="btn custom-card-header-filter btn-transparent btn:focus"
							@click="favoriteRequest(ask._id, 'unfavorite')">
							<md-tooltip md-direction="bottom">unfavorite</md-tooltip>
								<i class="fa fa-star fa-lg gold-color" aria-hidden="true"></i>
							</button>
						</span>
						<span v-else>
							<button type="button" class="btn custom-card-header-filter btn-transparent btn:focus"
							@click="favoriteRequest(ask._id,  'favorite')">
							<md-tooltip md-direction="bottom">favorite</md-tooltip>
							<i class="far fa-star fa-lg" aria-hidden="true"></i></button>
						</span>
					</div>
					<div>
					<ul class="list-inline align-right btnleftspaceremove owner-li">
						<li class="w-30" v-if="ask.status != '(7) Closed' && ask.status != '(8) Rejected'">
							<md-field class="mt-2">
								<md-select class="owner-select" v-model="selectedOwner" name="owner" id="owner" placeholder="Owner">
									<md-option value="">Owner (none)</md-option>
									<md-option v-for="singleOwner in allOwners" v-bind:key="singleOwner._id" :value="singleOwner.email">{{ singleOwner.email }}</md-option>
								</md-select>
							</md-field>
						</li>
						<li v-for="action in availableInteractions" :interaction="action" :key="action">
							<md-button class="md-raised md-round md-accent capitalize" v-bind:class="action === 'coach' ? 'new-coach-btn' : ''" v-on:click="doInteraction(action)">{{ action }}</md-button>
							<!-- <md-button class="md-raised md-round capitalize" v-bind:class="reserveTxt === 'Reserve' ? 'reserve-btn' : 'reserved-btn'" v-on:click="reserveClick(reserveStatus)" v-if="getStatus !== 'Closed' && getStatus !== 'Rejected' && reserveBtn === true">{{reserveTxt}}</md-button> -->
						</li>
						<li v-if="getStatus === 'Add Tags'">
							<md-button class="md-raised md-round md-accent capitalize" v-on:click="saveTag()" >Add Tags</md-button>
						</li>
						<li v-if="escalateBtn == true" class="pl-0">
							<md-button class="md-raised md-round md-accent capitalize" style="background-color:#F2C057" @click="showDialog = true" >Request Support</md-button>
						</li>
						<li v-if="getStatus === 'Pending'">
							<md-button class="md-raised md-round capitalize capitalize request-status-btn" v-on:click="doInteraction('approve')">Super Admin Approval</md-button>
						</li>
					</ul>
					</div>
					<md-dialog :md-active.sync="showDialog" class="request-support">
						<md-dialog-title>Request Support</md-dialog-title>
						<md-field >
							<label>Message</label>
							<md-textarea v-model="requestSupportMsg" maxlength="1000" md-counter="1000" @input="sanitizeRequestSupport"></md-textarea>
						</md-field>
						<md-dialog-actions>
							<md-button class="md-primary" @click="cancelRequestSupport()">Cancel</md-button>
							<template>
								<md-button class="md-primary md-save"  :disabled="requestSupportMsg.length == 0" @click="requestSupportSubmit()">Submit</md-button>
							</template>
						</md-dialog-actions>
					</md-dialog>
					<md-dialog :md-active.sync="coachDialog" class="coach-box">
						<md-dialog-title>Coach</md-dialog-title>
						<md-field >
							<label>Message</label>
							<md-textarea v-model="coachMsg" md-autogrow @input="sanitizeCoachMsg"></md-textarea>

						</md-field>
						<md-dialog-actions>
							<md-button class="md-primary" @click="cancelCoach()">Cancel</md-button>
							<template>
								<md-button class="md-primary md-save"  :disabled="coachMsg.length == 0" @click="coachSubmit()">Submit</md-button>
							</template>
						</md-dialog-actions>
					</md-dialog>
					<md-dialog :md-active.sync="AdminApprovalDialog" class="admin-request-approve">
				      	<md-dialog-title>Are you sure you want to approve this request?</md-dialog-title>
 				  		<md-dialog-actions>
				        	<md-button class="md-primary yes-btn" @click="AdminApproval()">Yes</md-button>
				        	<md-button class="md-primary no-btn" @click="AdminApprovalDialog = false">No</md-button>
				      	</md-dialog-actions>
				    </md-dialog>
			</div>
			</md-card-content>
		</md-card>
		<md-card class="mt-30">
			<md-card-header class="ask-subject" :style="communityStyle">
				<ul class="list-inline mb-0">
					<li>
						{{ $lodash.has(community, 'name') ? community.name + ': ' + (ask.subject ? ask.subject : 'N/A') :
							(ask.subject ? ask.subject : 'N/A')}}
						<span
							v-if="ask.matchingCriteria && ask.matchingCriteria.assignment && ask.matchingCriteria.assignment.autoRefill === true"
							style="vertical-align: middle; margin-left: 6px;">
							<!-- Green recycle icon SVG -->
							<svg width="18" height="18" viewBox="0 0 24 24" style="vertical-align: middle;"
								fill="#004D40">
								<path
									d="M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z" />
							</svg>
						</span>
					</li>
					<span style="margin-left: 15px;">
						<template v-for="star in ask.stars" :data-star-num="star">★</template>
						<span v-if="ask.deadline" style="margin-left:15px"
							:style="$moment(ask.deadline) < $moment() ? 'text-decoration:line-through' : ''">Deadline:
							{{ tinyDate(ask.deadline) }}</span>
					</span>
					<li class="count" v-if="ask.comments && ask.comments.length">{{ ask.comments.length }}</li>
				</ul>
		</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" :community="community" :feedbacks="feedbacks" editAsk="true" />
		<approval-guidance-card class="mt-30" ref="approvalGuidance" :evaluation="analysis"
			:request-text="ask.text || ''" @generate="handleGenerateEvaluation"
			@scroll-to-responses="openAndScrollToResponses" />
		<md-card class="mt-30">
			<md-card-header md-alignment="space-between" class="md-title m-left-5">Request</md-card-header>
			<md-card-content class="card-content">
				<form>
					<md-field class="create-ask m-left-5">
						<label class="card-header">Subject</label>
						<md-input name="subject" v-model.trim="ask.subject" placeholder="Request summary..."
							@input="sanitizeSubject" @change="saveAskContent('subject')"></md-input>
					</md-field>
					<div class="create-ask ask-description-area form-group m-left-5">
						<label class="card-header" for="textarea">Description</label>
						<textarea rows="14" class="form-control description remove-box-shadow font-16" id="textarea"
							v-model.trim="formattedText" placeholder="Describe the request..."
							@input="sanitizeDescription" @change="saveAskContent('description')"></textarea>
					</div>
				</form>
			</md-card-content>
		</md-card>
	    <md-card class="mt-30">
		      <md-card-expand>
		        <md-card-actions md-alignment="space-between">
		        <md-card-expand-trigger>
						<md-button class="expand-button-size"><strong @click="expand('tag')" class="upper-word">Tags
							<span
									v-text="`(${$lodash.has(ask.tags, 0) ? ask.tags.length : '0'})`"></span></strong></md-button>
					</md-card-expand-trigger>
					<span @click.stop="athenaLoading ? null : handleGenerateEvaluation()"
						style="display: inline-flex; align-items: center; gap: 4px; font-size: 11px; color: #6366f1; cursor: pointer; margin-right: 16px; font-weight: normal; opacity: 1; transition: opacity 0.2s;"
						:style="{ opacity: athenaLoading ? 0.6 : 1, cursor: athenaLoading ? 'not-allowed' : 'pointer' }">
						<md-icon :style="{
							color: '#6366f1',
							fontSize: '14px !important',
							animation: athenaLoading ? 'spin 1s linear infinite' : 'none',
							verticalAlign: 'middle'
						}">autorenew</md-icon>
						{{ athenaLoading ? 'Analyzing...' : 'Re-run Analysis' }}
					</span>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="card-content md-scrollbar scrollbar">
						<template v-if="opened.includes('tag')">
							<div class="flex-box tag-vertical-scroll" v-if="ask.tags.length">
								<template v-for="tag in ask.tags">
	      						<md-chip class="flex-child md-style-chip" md-deletable :key="tag" @click="removeTag(tag)">{{tag}}</md-chip>
	      					</template>
	      				</div>
	      				<form @submit.prevent="addTags">
	      					<md-field class="m-left-10">
	      						<md-input v-model="tags" placeholder="Add tag..." @input="sanitizeTags"></md-input>
	      					</md-field>
	      				</form>
<!--	      				<div class="ask-header font-18 m-left-10">
	      					Suggested Tags
	      				</div>
	      				<div class="flex-box">
		      				<template v-for="suggestedTag in suggestedTags">
								<md-chip class="flex-child md-style-chip" @click="addSuggested(suggestedTag)" v-bind:key="suggestedTag" md-static md-clickable>{{suggestedTag}}</md-chip>
							</template>
						</div>
						-->
					</template>
				</md-card-content>
	        </md-card-expand-content>
	      </md-card-expand>
	    </md-card>
		<md-card class="mt-30 adviser-section" v-if="adviserMatchSection === true" id="adviser-match-section">
		      <md-card-expand>
		        <md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('adviser-match')" class="upper-word">Advisers <span v-text="`(${matchedAdvisors.length})`"></span></strong></md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
      		<md-card-expand-content>
      			<md-card-content class="card-content" v-if="opened.includes('adviser-match')">
				  <md-table class="ask-response-table" v-if="matchedAdvisors.length">
                        <md-table-row>
                            <md-table-head class="card-header remove-table-head-margin minus-icon-remove-margin"></md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Name</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Score</span>
								&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortScore === 'desc'" @click="sortMatchedAdviser('asc','score')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortScore === 'asc'" @click="sortMatchedAdviser('desc','score')" />
							</md-table-head>
                            <!-- <md-table-head class="card-header remove-table-head-margin"><span>Community</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortCommunity === 'desc'" @click="sortMatchedAdviser('asc','community')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortCommunity === 'asc'" @click="sortMatchedAdviser('desc','community')" />
							</md-table-head> -->
                            <md-table-head class="card-header remove-table-head-margin"><span>Freq</span>
								&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortFreq === 'desc'" @click="sortMatchedAdviser('asc','frequency')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortFreq === 'asc'" @click="sortMatchedAdviser('desc','frequency')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Last Request Rec'd</span>
								&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortLastReqRec === 'desc'" @click="sortMatchedAdviser('asc','last_request')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortLastReqRec === 'asc'" @click="sortMatchedAdviser('desc','last_request')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Response</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortLastResponse === 'desc'" @click="sortMatchedAdviser('asc','last_response')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortLastResponse === 'asc'" @click="sortMatchedAdviser('desc','last_response')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Email</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Status</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Action</md-table-head>
                        </md-table-row>
						<template v-for="(matchedAdvisor, index) in matchedAdvisors" v-if="matchedAdvisor._id !== ask.createdByMemberID && matchedAdvisors.length">
							<md-table-row class="response-section" :key="matchedAdvisor._id" @click="expandAdviserSection(matchedAdvisor._id)">
								<md-table-cell class="minus-icon-remove-margin">
								<md-button class="md-mini md-fab btnplain" @click="removeFromMatchedAdviser(matchedAdvisor, index)">
									<font-awesome-icon class="picker-icon-danger font-24" icon="minus-circle" />
								</md-button>
								</md-table-cell>
								<md-table-cell v-if="matchedAdvisor && matchedAdvisor._id"><span class="display-link" @click="goToProfile(matchedAdvisor._id)">{{matchedAdvisor.name}}</span></md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell>{{ matchedAdvisor.score + '%' }}</md-table-cell>
								<!-- <md-table-cell>{{matchedAdvisor.community}}</md-table-cell> -->
								<md-table-cell v-if="matchedAdvisor.frequency">{{ matchedAdvisor.frequency }}</md-table-cell>
	        					<md-table-cell v-else>W</md-table-cell>
								<md-table-cell v-if="matchedAdvisor.last_request">{{matchedAdvisor.last_request | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell v-if="matchedAdvisor.last_response">{{matchedAdvisor.last_response | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell>{{getAdviserSectionStatus(matchedAdvisor._id)}}</md-table-cell>
								<md-table-cell>{{matchedAdvisor.eventData}}</md-table-cell>
								<md-table-cell v-if="matchedAdvisor && matchedAdvisor._id">
									<span class="display-link display-resend-link" @click="resendEmail(matchedAdvisor._id, matchedAdvisor.email, $route.params.ask_id)">Resend</span>
								</md-table-cell>
							</md-table-row>
								<div v-bind:key="'adviser-row-'+index" class="table-row" v-if="expandAdviser.includes(matchedAdvisor._id)">
									<md-table-cell colspan="10">
										<div class="row">
											<div class="col-sm-4">
												<div class="m-left-10 mt-20" v-if="matchedAdvisor.linkedIn">
													<p>
														<span @click="goToLinkedInProfile(matchedAdvisor.linkedIn)" class="display-link">{{matchedAdvisor.linkedIn}}</span>
													</p>
												</div>
										        <div class="m-left-10 mt-20">
													<div>
														<span v-if="matchedAdvisor.role">{{matchedAdvisor.role}}</span>
														<span v-if="matchedAdvisor.organization">{{', ' + matchedAdvisor.organization}}</span>
													</div>
													<div>
														<span v-if="matchedAdvisor.city">{{matchedAdvisor.city}}</span>
														<span v-if="matchedAdvisor.state">{{', ' + matchedAdvisor.state}}</span>
													</div>
												</div>
										    </div>
										    <div class="col-sm-8">
										        <div class="m-left-10 mt-20">
										            <div v-if="matchedAdvisor.school1">
										                {{matchedAdvisor.school1}}
										            </div>
										            <div v-if="matchedAdvisor.department1">
										                {{matchedAdvisor.department1}}
										            </div>
										            <div v-if="matchedAdvisor.major1">
										                {{matchedAdvisor.major1}}
                                </div>
                                <div v-if="matchedAdvisor.major2">
                                    {{matchedAdvisor.major2}}
                                </div>
                                <div v-if="matchedAdvisor.major3">
                                    {{matchedAdvisor.major3}}
										            </div>
										            <div v-if="matchedAdvisor.year1">
										                {{matchedAdvisor.year1}}
										            </div>
										        </div>
										    </div>
										</div>
										<!-- <p class="m-left-10 mt-20">
											<span v-if="matchedAdvisor.role">{{matchedAdvisor.role}}</span>
											<span v-if="matchedAdvisor.organization">{{', ' + matchedAdvisor.organization}}</span>
										</p>
										<p class="m-left-10 mt-20">
											<span v-if="matchedAdvisor.city">{{matchedAdvisor.city}}</span>
											<span v-if="matchedAdvisor.state">{{', ' + matchedAdvisor.state}}</span>
										</p> -->
										<div class="bio1" v-if="matchedAdvisor.bio">
											<p class="md-body-1 light bio-paragraph">{{matchedAdvisor.bio}}</p>
										</div>
										<div class="row">
											<div class="flex-box">
												<md-chip class="flex-child" v-if="skill"  v-for="(skill, idx) in matchedAdvisor.skills" :key="skill+idx" md-disabled>{{skill}}</md-chip>
											</div>
										</div>
									</md-table-cell>
								</div>
						</template>
					</md-table>
					<md-field>
						<button @click="getAllAdvList()" :disabled="searchAdvisors.trim().length < 3 == 1" title="Search" aria-label="Search advisors" class="search-addon-btnstyle md-button md-accent card-header md-theme-default"><i class="fa fa-search"></i></button>
						<md-input v-model="searchAdvisors" @input="sanitizeSearchAdvisors" @keyup.enter="searchAdvisors.trim().length >= 3 ? getAllAdvList() : ''" name="searchAdvisor" placeholder="Search advisors..."></md-input>
					</md-field>
					<md-table class="ask-response-table margin-top-20" v-if="suggestedAdvisors.length">
						<md-table-row>
							<md-table-head class="card-header remove-table-head-margin plus-icon-remove-margin"></md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Name</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Score</span>
								&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortScore === 'desc'" @click="sortSuggestedAdviser('asc','score')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortScore === 'asc'" @click="sortSuggestedAdviser('desc','score')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Community</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortCommunity === 'desc'" @click="sortSuggestedAdviser('asc','community')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortCommunity === 'asc'" @click="sortSuggestedAdviser('desc','community')" />
							</md-table-head>
							<md-table-head v-if="suggestedAdvisorType == 'volunteer' || suggestedAdvisorType == 'vip'" class="card-header remove-table-head-margin"><span>Type</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortMemberRank === 'desc'" @click="sortSuggestedAdviser('asc','member_rank')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortMemberRank === 'asc'" @click="sortSuggestedAdviser('desc','member_rank')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Freq</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortFreq === 'desc'" @click="sortSuggestedAdviser('asc','frequency')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortFreq === 'asc'" @click="sortSuggestedAdviser('desc','frequency')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span> Request Rec'd</span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortLastReqRec === 'desc'" @click="sortSuggestedAdviser('asc','last_request')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortLastReqRec === 'asc'" @click="sortSuggestedAdviser('desc','last_request')" /></md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span> Response </span>
							&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="newCurrentSuggestedSortLastResponse === 'desc'" @click="sortSuggestedAdviser('asc','last_response')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="newCurrentSuggestedSortLastResponse === 'asc'" @click="sortSuggestedAdviser('desc','last_response')" />
							</md-table-head>
						</md-table-row>
						<template v-for="(suggestedAdvisor, index) in suggestedAdvisors">
							<md-table-row class="response-section" v-if="index < showSuggestedAdviser" :key="suggestedAdvisor._id" @click="expandSuggestedAdviserSection(suggestedAdvisor._id)">
								<md-table-cell class="plus-icon-remove-margin">
								<md-button class="md-mini md-fab btnplain" @click="addToMatchedAdviser(suggestedAdvisor, index)">
									<font-awesome-icon class="picker-icon font-24" icon="plus-circle" />
								</md-button>
								</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor && suggestedAdvisor._id"><span class="display-link" @click="goToProfile(suggestedAdvisor._id)">{{suggestedAdvisor.name}}</span></md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell>{{ suggestedAdvisor.score+'%' }}</md-table-cell>
								<md-table-cell>{{suggestedAdvisor.community}}</md-table-cell>
								<md-table-cell v-if="(suggestedAdvisorType == 'volunteer' || suggestedAdvisorType == 'vip') && suggestedAdvisor.member_rank && suggestedAdvisor.member_rank.length">{{ suggestedAdvisor.member_rank.toString() }}</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.frequency">{{ suggestedAdvisor.frequency }}</md-table-cell>
	        					<md-table-cell v-else>W</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.last_request">{{suggestedAdvisor.last_request | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.last_response">{{suggestedAdvisor.last_response | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
							</md-table-row>
								<div v-bind:key="'suggested-adviser-row-'+index" class="table-row" v-if="expandSuggestedAdviser.includes(suggestedAdvisor._id)">
									<md-table-cell colspan="10">
										<div class="row">
											<div class="col-sm-4">
												<div class="m-left-10 mt-20" v-if="suggestedAdvisor.linkedIn">
													<p>
														<span @click="goToLinkedInProfile(suggestedAdvisor.linkedIn)" class="display-link">{{suggestedAdvisor.linkedIn}}</span>
													</p>
												</div>
										        <div class="m-left-10 mt-20">
													<div>
														<span v-if="suggestedAdvisor.role">{{suggestedAdvisor.role}}</span>
														<span v-if="suggestedAdvisor.organization">{{', ' + suggestedAdvisor.organization}}</span>
													</div>
										        	<div>
														<span v-if="suggestedAdvisor.city">{{suggestedAdvisor.city}}</span>
														<span v-if="suggestedAdvisor.state">{{', ' + suggestedAdvisor.state}}</span>
										        	</div>
												</div>
										    </div>
										    <div class="col-sm-8">
										        <div class="m-left-10 mt-20">
										            <div v-if="suggestedAdvisor.school1">
										                {{suggestedAdvisor.school1}}
										            </div>
										            <div v-if="suggestedAdvisor.department1">
										                {{suggestedAdvisor.department1}}
										            </div>
										            <div v-if="suggestedAdvisor.major1">
										                {{suggestedAdvisor.major1}}
										            </div>
                                <div v-if="suggestedAdvisor.major2">
														        {{suggestedAdvisor.major2}}
													      </div>
													      <div v-if="suggestedAdvisor.major3">
														        {{suggestedAdvisor.major3}}
													      </div>
										            <div v-if="suggestedAdvisor.year1">
										                {{suggestedAdvisor.year1}}
										            </div>
										        </div>
										    </div>
										</div>
										<!-- <p class="m-left-10 mt-20">
											<span v-if="suggestedAdvisor.role">{{suggestedAdvisor.role}}</span>
											<span v-if="suggestedAdvisor.organization">{{', ' + suggestedAdvisor.organization}}</span>
										</p>
										<p class="m-left-10 mt-20">
											<span v-if="suggestedAdvisor.city">{{suggestedAdvisor.city}}</span>
											<span v-if="suggestedAdvisor.state">{{', ' + suggestedAdvisor.state}}</span>
										</p> -->
										<div class="bio1" v-if="suggestedAdvisor.bio">
											<p class="md-body-1 light bio-paragraph">{{suggestedAdvisor.bio}}</p>
										</div>
										<div class="row">
											<div class="flex-box">
												<md-chip class="flex-child" v-if="skill" v-for="(skill, idx) in suggestedAdvisor.skills" :key="skill+idx" md-disabled>{{skill}}</md-chip>
											</div>
										</div>
									</md-table-cell>
								</div>
						</template>
					</md-table>
					<div class="row mt-20 bottom-loadMore">
						<div class="col-md-6 col-xs-6 text-right">
							<md-button class="md-mini btnplain capitalize card-header" @click="showSuggestedAdviser += 5" v-if="suggestedAdvisors.length > showSuggestedAdviser">Load More</md-button>
						</div>
						<div class="col-md-6 col-xs-6 text-right">
							<div class="match-dropdown">
								<div class="w-28">
									<md-field>
										<md-select @md-closed="selectMatchAdvser()" name="matchAdvisor" v-model="suggestedAdvisorType" placeholder="Select match option" >
											<md-option value="acceptedResponse">Match Acpt. Resp.</md-option>
											<md-option value="AllMatch">Match All</md-option>
											<md-option value="matchNoRequest">Match No-Request</md-option>
											<md-option value="vip">Match VIP</md-option>
											<md-option value="volunteer">Match Volunteers</md-option>
										</md-select>
									</md-field>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="w-100 text-center mt-20">
						<md-button class="md-mini btnplain capitalize card-header" @click="showSuggestedAdviser += 5" v-if="suggestedAdvisors.length > showSuggestedAdviser">Load More</md-button>
						<md-button class="md-mini md-raised md-accent capitalize float-right md-white-color" v-if="isMatchBtnShow" @click="rematchAdviserSection('AllMatch')">Match</md-button>
						<md-button class="md-mini md-raised md-accent capitalize float-right md-white-color" @click="rematchAdviserSection('volunteer')">volunteers</md-button>
					</div> -->
					<div class="text-right theme-pagination" v-if="pageCount != 0">
						<ul class="list-inline align-right mtm-3">
							<li>
								<div class="form-group goToPage">
									<label>Go to page:</label>
									<select v-model="page" name="page_number" id="page_number" @change="goToPage()">
										<option v-for="n in pageCount" :key="n" :value="n">{{n}}</option>
									</select>
								</div>
							</li>
							<li>
								<paginate
									v-model="page"
									:page-count="pageCount"
									:page-range="3"
									:margin-pages="2"
									:click-handler="matchAdviserList"
									:prev-text="'Prev'"
									:next-text="'Next'"
									:container-class="'pagination'"
									:page-class="'page-item'">
								</paginate>
								<md-button class="md-mini md-fab btnplain refreshBtn" title="Refresh" @click="refreshBtn()">
									<img src="../assets/refresh.png">
								</md-button>
							</li>
						</ul>
					</div>
				</md-card-content>
	        </md-card-expand-content>
	      </md-card-expand>
	    </md-card>
	    <md-card class="mt-30 adviser-section" v-if="adviserMatchSection === false">
		      <md-card-expand>
				<md-card-actions md-alignment="space-between">
		        	<md-card-expand-trigger>
		        		<md-button class="expand-button-size"><strong @click="expand('adviser')" class="upper-word">Advisers <span v-text="ask.recommendedAdvisors ? `(${ask.recommendedAdvisors.length})` : `(0)`"></span></strong>
								<a :href="`/gemini-match/${ask._id}`" target="_new">Gemini</a>
								</md-button>
      				</md-card-expand-trigger>
      			</md-card-actions>
      		<md-card-expand-content>
      			<md-card-content class="card-content" v-if="opened.includes('adviser')">
				  <md-table class="ask-response-table" v-if="matchedAdvisors.length">
                        <md-table-row>
                            <md-table-head class="card-header remove-table-head-margin minus-icon-remove-margin"></md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Name</md-table-head>
                            <!-- <md-table-head class="card-header remove-table-head-margin"><span>Community</span>
							</md-table-head> -->
                            <md-table-head class="card-header remove-table-head-margin"><span>Freq</span>
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Last Request Rec'd</span>
								&nbsp;<font-awesome-icon class="selector font-24 float-right" icon="caret-down" v-if="currentMatchedSortLastReqRec === 'desc'" @click="sortMatchedAdviser('asc','last_request')" />
								<font-awesome-icon class="selector font-24 float-right" icon="caret-up" v-if="currentMatchedSortLastReqRec === 'asc'" @click="sortMatchedAdviser('desc','last_request')" />
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Response</span>
							</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Email</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Status</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Action</md-table-head>
                        </md-table-row>
						<template v-for="(matchedAdvisor, index) in matchedAdvisors" v-if="matchedAdvisor._id !== ask.createdByMemberID && matchedAdvisors.length">
							<md-table-row class="response-section" :key="matchedAdvisor._id" @click="expandAdviserSection(matchedAdvisor._id)">
								<md-table-cell class="minus-icon-remove-margin">
								<md-button class="md-mini md-fab btnplain" @click="removeFromMatchedAdviser(matchedAdvisor, index)">
									<font-awesome-icon class="picker-icon-danger font-24" icon="minus-circle" />
								</md-button>
								</md-table-cell>
								<md-table-cell v-if="matchedAdvisor && matchedAdvisor._id"><span class="display-link" @click="goToProfile(matchedAdvisor._id)">{{matchedAdvisor.name}}</span></md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<!-- <md-table-cell>{{matchedAdvisor.community}}</md-table-cell> -->
								<md-table-cell v-if="matchedAdvisor.frequency">{{ matchedAdvisor.frequency }}</md-table-cell>
	        					<md-table-cell v-else>W</md-table-cell>
								<md-table-cell v-if="matchedAdvisor.last_request">{{matchedAdvisor.last_request | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell v-if="matchedAdvisor.last_response">{{matchedAdvisor.last_response | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell>{{getAdviserSectionStatus(matchedAdvisor._id)}}</md-table-cell>
								<md-table-cell>{{matchedAdvisor.eventData}}</md-table-cell>
								<md-table-cell v-if="matchedAdvisor && matchedAdvisor._id">
									<span class="display-link display-resend-link" @click="resendEmail(matchedAdvisor._id, matchedAdvisor.email, $route.params.ask_id)">Resend</span>
								</md-table-cell>
							</md-table-row>
								<div v-bind:key="'adviser-row-'+index" class="table-row" v-if="expandAdviser.includes(matchedAdvisor._id)">
									<md-table-cell colspan="10">
										<div class="row">
										    <div class="col-sm-4">
												<div class="m-left-10 mt-20" v-if="matchedAdvisor.linkedIn">
													<p>
														<span @click="goToLinkedInProfile(matchedAdvisor.linkedIn)" class="display-link">{{matchedAdvisor.linkedIn}}</span>
													</p>
												</div>
												<div class="m-left-10 mt-20">
													<div>
														<span v-if="matchedAdvisor.role">{{matchedAdvisor.role}}</span>
														<span v-if="matchedAdvisor.organization">{{', ' + matchedAdvisor.organization}}</span>
													</div>
										       		<div>
														<span v-if="matchedAdvisor.city">{{matchedAdvisor.city}}</span>
														<span v-if="matchedAdvisor.state">{{', ' + matchedAdvisor.state}}</span>
										       		</div>
										        </div>
										    </div>
										    <div class="col-sm-8">
										        <div class="m-left-10 mt-20">
										            <div v-if="matchedAdvisor.school1">
										                {{matchedAdvisor.school1}}
										            </div>
										            <div v-if="matchedAdvisor.department1">
										                {{matchedAdvisor.department1}}
										            </div>
										            <div v-if="matchedAdvisor.major1">
										                {{matchedAdvisor.major1}}
										            </div>
										            <div v-if="matchedAdvisor.year1">
										                {{matchedAdvisor.year1}}
										            </div>
										        </div>
										    </div>
										</div>
										<!-- <p class="m-left-10 mt-20">
											<span v-if="matchedAdvisor.city">{{matchedAdvisor.city}}</span>
											<span v-if="matchedAdvisor.state">{{', ' + matchedAdvisor.state}}</span>
										</p> -->
										<div class="bio1" v-if="matchedAdvisor.bio">
											<p class="md-body-1 light bio-paragraph">{{matchedAdvisor.bio}}</p>
										</div>
										<div class="row">
											<div class="flex-box">
												<md-chip class="flex-child" v-if="skill" v-for="(skill, idx) in matchedAdvisor.skills" :key="skill+idx" md-disabled>{{skill}}</md-chip>
											</div>
										</div>
									</md-table-cell>
								</div>
						</template>
					</md-table>
					<md-field>
						<button @click="getAllAdvList()" :disabled="searchAdvisors.trim().length < 3 == 1" title="Search" aria-label="Search advisors" class="search-addon-btnstyle md-button md-accent card-header md-theme-default"><i class="fa fa-search"></i></button>
						<md-input v-model="searchAdvisors" @input="sanitizeSearchAdvisors" @keyup.enter="searchAdvisors.trim().length >= 3 ? getAllAdvList() : ''" name="searchAdvisor" placeholder="Search advisors..."></md-input>
					</md-field>
					<md-table class="ask-response-table margin-top-20" v-if="suggestedAdvisors.length">
						<md-table-row>
							<md-table-head class="card-header remove-table-head-margin plus-icon-remove-margin"></md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Name</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Community</span>
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span>Freq</span>
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span> Request Rec'd</span>
							</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin"><span> Response </span>
							</md-table-head>
						</md-table-row>
						<template v-for="(suggestedAdvisor, index) in suggestedAdvisors">
							<md-table-row class="response-section" :key="suggestedAdvisor._id" @click="expandSuggestedAdviserSection(suggestedAdvisor._id)">
								<md-table-cell class="plus-icon-remove-margin">
								<md-button class="md-mini md-fab btnplain" @click="addToMatchedAdviser(suggestedAdvisor, index)">
									<font-awesome-icon class="picker-icon font-24" icon="plus-circle" />
								</md-button>
								</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor && suggestedAdvisor._id"><span class="display-link" @click="goToProfile(suggestedAdvisor._id)">{{suggestedAdvisor.name}}</span></md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell>{{suggestedAdvisor.community}}</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.frequency">{{ suggestedAdvisor.frequency }}</md-table-cell>
	        					<md-table-cell v-else>W</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.last_request">{{suggestedAdvisor.last_request | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
								<md-table-cell v-if="suggestedAdvisor.last_response">{{suggestedAdvisor.last_response | momentDate}}</md-table-cell>
								<md-table-cell v-else>N/A</md-table-cell>
							</md-table-row>
								<div v-bind:key="'suggested-adviser-row-'+index" class="table-row" v-if="expandSuggestedAdviser.includes(suggestedAdvisor._id)">
									<md-table-cell colspan="10">
										<div class="row">
											<div class="col-sm-4">
												<div class="m-left-10 mt-20" v-if="suggestedAdvisor.linkedIn">
													<p>
														<span @click="goToLinkedInProfile(suggestedAdvisor.linkedIn)" class="display-link">{{suggestedAdvisor.linkedIn}}</span>
													</p>
												</div>
										        <div class="m-left-10 mt-20">
													<div>
														<span v-if="suggestedAdvisor.role">{{suggestedAdvisor.role}}</span>
														<span v-if="suggestedAdvisor.organization">{{', ' + suggestedAdvisor.organization}}</span>
											        </div>
													<div>
														<span v-if="suggestedAdvisor.city">{{suggestedAdvisor.city}}</span>
														<span v-if="suggestedAdvisor.state">{{', ' + suggestedAdvisor.state}}</span>
													</div>
												</div>
										    </div>
										    <div class="col-sm-8">
										        <div class="m-left-10 mt-20">
										            <div v-if="suggestedAdvisor.school1">
										                {{suggestedAdvisor.school1}}
										            </div>
										            <div v-if="suggestedAdvisor.department1">
										                {{suggestedAdvisor.department1}}
										            </div>
										            <div v-if="suggestedAdvisor.major1">
										                {{suggestedAdvisor.major1}}
										            </div>
										            <div v-if="suggestedAdvisor.year1">
										                {{suggestedAdvisor.year1}}
										            </div>
										        </div>
										    </div>
										</div>
										<!-- <p class="m-left-10 mt-20">
											<span v-if="suggestedAdvisor.role">{{suggestedAdvisor.role}}</span>
											<span v-if="suggestedAdvisor.organization">{{', ' + suggestedAdvisor.organization}}</span>
										</p>
										<p class="m-left-10 mt-20">
											<span v-if="suggestedAdvisor.city">{{suggestedAdvisor.city}}</span>
											<span v-if="suggestedAdvisor.state">{{', ' + suggestedAdvisor.state}}</span>
										</p> -->
										<div class="bio1" v-if="suggestedAdvisor.bio">
											<p class="md-body-1 light bio-paragraph">{{suggestedAdvisor.bio}}</p>
										</div>
										<div class="row">
											<div class="flex-box">
												<md-chip class="flex-child" v-for="(skill, idx) in suggestedAdvisor.skills" :key="skill+idx" md-disabled>{{skill}}</md-chip>
											</div>
										</div>
									</md-table-cell>
								</div>
						</template>
					</md-table>
					<div class="row mt-20 bottom-loadMore">
						<div class="col-md-6 col-xs-6 text-right">
							<md-button class="md-mini btnplain capitalize card-header" @click="sugAdvData('loadMore')" v-if="sugAdvSkip + sugAdvLimit < sugAdvCount">Load More</md-button>
						</div>
						<div class="col-md-6 col-xs-6 text-right">
							<div class="match-dropdown">
								<div class="w-28">
									<md-field>
										<md-select @md-closed="selectMatchAdvser()" name="matchAdvisor" v-model="suggestedAdvisorType" placeholder="Select match option" >
											<md-option value="acceptedResponse">Match Acpt. Resp.</md-option>
											<md-option value="AllMatch">Match All</md-option>
											<md-option value="matchNoRequest">Match No-Request</md-option>
											<md-option value="vip">Match VIP</md-option>
											<md-option value="volunteer">Match Volunteers</md-option>
										</md-select>
									</md-field>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="text-center mt-20">
						<md-button class="md-mini btnplain capitalize card-header" @click="sugAdvData('loadMore')" v-if="sugAdvSkip + sugAdvLimit < sugAdvCount">Load More</md-button>
						<md-button class="md-mini md-raised md-accent capitalize float-right md-white-color" @click="rematchAdviserSection('AllMatch')">Match</md-button>
						<md-button class="md-mini md-raised md-accent capitalize float-right md-white-color" @click="rematchAdviserSection('volunteer')">volunteers</md-button>
					</div> -->
				</md-card-content>
	        </md-card-expand-content>
	      </md-card-expand>
	    </md-card>
	    <md-card class="mt-30" id="response-section">
		<md-card-expand>
				<md-card-actions md-alignment="space-between">
					<md-card-expand-trigger>
						<md-button ref="responseExpandBtn" class="expand-button-size" @click="expand('response')">
							<strong class="upper-word">Responses
								<span v-text="`(${responseSectionCount})`"></span>
							</strong>
						</md-button> </md-card-expand-trigger>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="card-content md-scrollbar scrollbar">
				  	<md-table class="ask-response-table">
                        <md-table-row>
                            <md-table-head class="card-header remove-table-head-margin">Name</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Email</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Community</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Responded</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Status</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Action</md-table-head>
                            <md-table-head class="card-header remove-table-head-margin">Sent</md-table-head>
							<md-table-head class="card-header remove-table-head-margin">Response Evaluation</md-table-head>
						</md-table-row>
							<template v-for="(give, index) in sortResponses">
								<md-table-row class="response-section" :key="give._id"
									@click="expandResponseSection(give._id); giveId = give._id">
								<md-table-cell v-if="give.advisors && give.advisors.length">
										<span class="display-link"
											@click="goToProfile(String(give.advisors[0]._id || give.advisors[0]))">
											{{ getAdviserDetails('name', String(give.advisors[0]._id ||
												give.advisors[0])) }}
										</span>
									</md-table-cell> <md-table-cell v-else>N/A</md-table-cell>
									<md-table-cell>
										{{ give.advisors && give.advisors.length ? getAdviserDetails('email',
											String(give.advisors[0]._id || give.advisors[0])) : give.email }}
									</md-table-cell>
									<!-- <md-table-cell>{{community ? community.name : 'N/A' }}</md-table-cell> -->
									<md-table-cell v-if="give.advisors && give.advisors.length">{{ community ?
										community.name : 'N/A' }}</md-table-cell>
									<md-table-cell v-else>N/A</md-table-cell>
									<md-table-cell>{{ give.when | momentDate }}</md-table-cell>
									<md-table-cell
										:class="[{ 'md-orange-color': ['In Review', 'Pending'].includes(give.responseState.currentState) }, { 'md-green-color': give.responseState.currentState === 'Approved' }, { 'md-red-color': give.responseState.currentState === 'Rejected' }, { 'md-yellow-color': give.giveType && give.giveType === 'referred' }, { 'md-blue-color': give.giveType && give.giveType === 'snoozed' }]"
										v-if="give.responseState && give.responseState.currentState">{{ give.giveType &&
											give.giveType === 'referred' ? 'Referred' : give.responseState &&
												give.responseState.currentState ? give.responseState.currentState : 'N/A'
										}}</md-table-cell>
									<md-table-cell v-else>N/A</md-table-cell>
									<md-table-cell v-if="give.action">{{ give.action }}</md-table-cell>
									<md-table-cell v-else>N/A</md-table-cell>
									<md-table-cell>
										{{ give.advisors && give.advisors.length ? getAdviserDetails('request-date',
											String(give.advisors[0]._id || give.advisors[0]), give._id) : 'N/A' }}
									</md-table-cell>

									<md-table-cell
										v-if="give.responseState && give.responseState.currentState === 'Pending'"><a
											:href="`/update-response-status/?askid=${ask._id}&giveid=${give._id}&status=approve&type=response&communityId=${community._id}`"
										target="_blank" class="button">Approve</a></md-table-cell>
									<md-table-cell
										v-if="give.responseEvaluation && give.responseEvaluation.recommended">
										<button class="eval-badge" :class="{
											'eval-pass': getStatusLabel(give.responseEvaluation) === 'PASS',
											'eval-caution': getStatusLabel(give.responseEvaluation) === 'CAUTION',
											'eval-fail': getStatusLabel(give.responseEvaluation) === 'FAIL'
										}" @click.stop="openEvalModal(give)">
											<span v-if="getStatusLabel(give.responseEvaluation) === 'PASS'">✔</span>
											<span
												v-else-if="getStatusLabel(give.responseEvaluation) === 'CAUTION'">⚠</span>
											<span v-else>✕</span>
											{{ getStatusLabel(give.responseEvaluation) }}
										</button>
									</md-table-cell>
									<md-table-cell v-else>
										<button class="eval-badge" style="background:#f0f0f0; color:#666;"
											:disabled="evaluatingGiveId === give._id"
											@click.stop="generateEvaluation(give)">
											{{ evaluatingGiveId === give._id ? 'Evaluating...' : 'Evaluate' }}
										</button>
									</md-table-cell>
								</md-table-row>
								<div class="table-row mt-20" :key="'give-expand-' + give._id"
									v-if="expandResponse.includes(give._id)">
									<md-table-cell colspan="8" v-if="give.helpaction != 'no' && give.responseState && give.responseState.currentState === 'In Review' || give.helpaction != 'no' && give.responseState.currentState === 'Rejected'">
									<textarea class="response-description" :id="'response-id-'+index" :data-id="'response-id-'+index" v-model.trim="give.insight" @change="editResponse(ask._id, give)" @input="sanitizeInsight($event, give)"></textarea>
									<md-card-actions class="card-actions" v-if="give.helpaction != 'no'">
										<md-button :class="[{'md-orange': action === 'Reject'}, 'md-raised', 'md-accent', 'md-round', 'float-right', 'capitalize', 'md-white-color', 'm-left-10']" v-for="action in give.responseState.availableStates" :interaction="action" :key="action" @click="responseActions(ask._id, give._id, action)">{{ action }}
										</md-button>
									</md-card-actions>
								</md-table-cell>
								<md-table-cell colspan="8" v-else-if="give.helpaction != 'no' && give.responseState && give.responseState.currentState === 'Approved'">
									<template v-if="give.action && ['Share Advice', 'Insight', 'Call Me'].includes(give.action)">
										<p class="ask-response-description">{{give.insight}}</p>
									</template>
									<div class="w-100 response-section-padding">
										<md-button class="md-raised md-accent md-round capitalize md-white-color float-left" @click="sendFeedbackToMember(give)">Get Feedback</md-button>
										<md-button class="md-raised md-accent md-round capitalize md-white-color float-left m-left-10" @click="sendResponseToMember(give)">Send Response</md-button>
									</div>
									<div v-if="!give.followUp" class="plr20">
										<template>
											<h4>Add Follow-up manually</h4>
											<md-radio v-model="followType[index]" :name="'followType'+index" :id="'followType-'+index" :data-id="'followType-'+index" @change="folloUpType('yes', index)" value="yes">Yes</md-radio>
											<md-radio v-model="followType[index]" :name="'followType'+index" :id="'followType-'+index" :data-id="'followType-'+index"  @change="folloUpType('no', index)" value="no">No</md-radio>
											<div class="" v-if="followType[index] == 'no'" >
												<textarea rows="5" class="response-description font-16" :id="'followMsg-'+index" :data-id="'followMsg-'+index" v-model.trim="followUpMessage[index]" @input="sanitizeFollowUpMessage($event, index)" :name="'followUpMessage'+index" placeholder="I have not followed up because ..."></textarea>
												<p class="error"
														v-if="followType[index] && !followUpMessage[index]">Please enter
														your response follow-up reason</p>
												</div>
												<div v-if="followType[index]">
													<md-button
														class="md-raised md-accent md-round capitalize md-white-color float-left"
														@click="submitFollowUp(give, index)">Submit</md-button>
												</div>
											</template>
										</div>
									</md-table-cell>
								</div>
							</template>
						</md-table>
						<div class="ask-manual-response">
							<h3 class="create-ask m-left-10 response-head1">Add Manual Response</h3>
							<show-adviser class="m-left-10 mt-10" v-on:chosen="addAdvisors"
								iconName="Search adviser"></show-adviser>
							<form @submit.prevent="addManualResponse">
								<p class="m-left-10 mt-10 font-18" v-if="adviserName.length">{{ adviserName }}</p>
								<p class="error m-left-10" v-show="adviserNameError.length" v-if="!adviserName.length">
									{{ adviserNameError }}</p>
								<md-field class="create-ask textareaAfter">
									<md-textarea name="insight" class="padding-left-10" v-model="responseInsight"
										v-validate="'required'" @input="sanitizeResponseInsight"
										placeholder="Response from advisor"></md-textarea>
								</md-field>
								<p class="error m-left-5" v-show="errors.has('insight')">{{ errors.first('insight') }}</p>
								<md-field class="create-ask">
									<md-button class="md-accent md-raised upper-word md-white-color" type="submit">Add
										Response</md-button>
								</md-field>
							</form>
						</div>
					</md-card-content>
				</md-card-expand-content>
		</md-card-expand>
		</md-card>
		<ask-feedback id="requestFeedback" class="mt-30" :ask="ask" :feedbacks="feedbacks">Feedback goes
			here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<email-log class="mt-30" :ask="ask">Email log goes here...</email-log>
		<activity-log class="mt-30" :ask="ask" :analysis="ask.analysis">Activity log goes here...</activity-log>
		<coach-log class="mt-30" :ask="ask">Coach logs go here...</coach-log>
		<md-dialog :md-active.sync="evalModalOpen" class="eval-modal">
			<md-dialog-content v-if="selectedEval">

				<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
					<div style="display: flex; align-items: center; gap: 10px;">
						<i :class="{
							'fa fa-check-circle': selectedEval.recommended.score === 'Approve',
							'fa fa-exclamation-circle': selectedEval.recommended.score === 'Approve with Caution',
							'fa fa-times-circle': selectedEval.recommended.score === 'Do Not Approve'
						}" :style="{
					fontSize: '20px',
					color: selectedEval.recommended.score === 'Approve' ? '#2e7d32' : selectedEval.recommended.score === 'Approve with Caution' ? '#e65100' : '#c62828'
				}"></i>
						<span style="font-size: 18px; font-weight: 600;">Response Evaluation</span>
					</div>
					<div style="display: flex; align-items: center; gap: 8px;">
					<span class="approval-verdict-badge" :class="{
							'verdict-approve': selectedEval.recommended.score === 'Approve',
							'verdict-caution': selectedEval.recommended.score === 'Approve with Caution',
							'verdict-reject': selectedEval.recommended.score === 'Do Not Approve'
						}" style="margin: 0;">
							{{ selectedEval.recommended.score === 'Approve' ? 'PASS'
								: selectedEval.recommended.score === 'Approve with Caution' ? 'CAUTION'
									: 'FAIL' }}
						</span>
						<i class="fa fa-times" style="cursor: pointer; color: #aaa; font-size: 14px;"
							@click="evalModalOpen = false"></i>
					</div>
				</div>
				<hr class="eval-divider" />

				<p
					style="font-size: 11px; font-weight: 600; color: #888; text-transform: uppercase; letter-spacing: 0.08em; margin: 12px 0 8px;">
					Reason</p>

				<p style="font-size: 14px; color: #444; line-height: 1.6; margin: 0 0 20px;">
					{{ selectedEval.summary.summary_of_results }}
				</p>

				<button @click="evalModalOpen = false"
					style="width: 100%; padding: 12px; background: #2196f3; color: white; border: none; border-radius: 24px; font-size: 15px; font-weight: 500; cursor: pointer;">Close</button>

			</md-dialog-content>
		</md-dialog>
	</div>
</template>

<script>
import API from "../services/API";
import AskDetail from "@/components/AskDetail";
import AskFeedback from "@/components/AskFeedback";
import Comments from "@/components/Comments";
import EmailLog from "@/components/EmailLog";
import ActivityLog from "@/components/ActivityLog";
import CoachLog from "@/components/CoachLog";
import axios from 'axios';
import ShowAdviser from "./ShowAdviser";
import Vue from 'vue';
import Paginate from 'vuejs-paginate'
import { sanitizeInput } from '../utils/sanitizer';
import ApprovalGuidanceCard from "@/components/ApprovalGuidanceCard";
Vue.component('paginate', Paginate)

export default {
	name: 'RequestDetail',
	components: {
		AskDetail,
		AskFeedback,
		Comments,
		ActivityLog,
		CoachLog,
		EmailLog,
		ShowAdviser,
		ApprovalGuidanceCard,

	},
	data() {
		return {
			evaluatingGiveId: null,
			evalModalOpen: false,
			selectedEval: null,
			analysis: null,
			athenaLoading: false,
			expandedEvals: [],
    		api: new API(),
    		ask: {},
    		community: {},
		 	communityStyle: {
		    	backgroundColor: "white",
		    	color: "black"
		  	},
			showDialog: false,
			coachDialog: false,
			requestSupportMsg: '',
      		fullPage: true,
		  	tags: '',
		  	suggestedTags: [],
		  	opened: [],
			selectedTag: '',
			status: '',
		  	availableStatus: ['(0) New', '(1) Tagged', '(2) Matched', '(3) Dispatched', '(4) Reminded', '(5) Responded'],
			responseSectionCount: 0,
			members: [],
			communities: [],
			expandResponse: [],
			expandAdviser: [],
			expandSuggestedAdviser: [],
			advisers: {},
			responseInsight: '',
			adviserName: '',
			adviserNameError: '',
			matchedAdvisors: [],
			suggestedAdvisors: [],
			availableFrequncy: [
				{'Not available': 'N/A'},
				{'Once a quarter': 'Q'},
				{'Once a week': 'W'},
				{'Once a month': 'M'},
				{'Daily': 'D'},
				{'As often as needed': 'A'}
    		],
			showSuggestedAdviser: 5,
			currentMatchedSortScore: 'desc',
			currentMatchedSortCommunity: 'desc',
			currentMatchedSortFreq: 'desc',
			currentMatchedSortLastReqRec: 'desc',
			currentMatchedSortLastResponse: 'desc',
			currentSuggestedSortScore: 'desc',
			currentSuggestedSortCommunity: 'desc',
			currentSuggestedSortFreq: 'desc',
			currentSuggestedSortLastReqRec: 'desc',
			currentSuggestedSortLastResponse: 'desc',
			newCurrentSuggestedSortScore: 'desc',
			newCurrentSuggestedSortCommunity: 'desc',
			newCurrentSuggestedSortMemberRank: 'desc',
			newCurrentSuggestedSortFreq: 'desc',
			newCurrentSuggestedSortLastReqRec: 'desc',
			newCurrentSuggestedSortLastResponse: 'desc',
			giveId: '',
			respondedMember: [],
			createdByMember: {},
			newAdmin: [],
			loaded: false,
			sugAdvCount: 0,
			sugAdvSkip: 5,
			sugAdvLimit: 5,
			sort: "",
			sortType: "",
			adviserMatchSection: false,
			feedbacks: [],
			sugAdvScoreSkip: 0,
			sugAdvScoreLimit: 2300,
			pageCount: 0,
			isMatchBtnShow: true,
			page: 1,
			escalateBtn: false,
			isDisplayScore: 'no',
			reserveTxt: 'Reserve',
			reserveBtn: false,
			reserveStatus: false,
			authUser: {},
			AdminApprovalDialog: false,
			suggestedAdvisorType: '',
			selectedMatchAdviser: '',
			followType: {},
			followUpMessage: {},
			isfollowUpMessage: {},
			isReserveOwner: false,
			searchAdvisors: '',
			allOwners: [],
			selectedOwner: "",
			ownerInitComplete: false, // ← guard flag
			coachMsg: ""
		}
	},
	watch: {
		currentMatchedSortScore: "matchedAdvisorsListWatcher",
		currentSuggestedSortScore: "suggestedAdvisorsListWatcher",
		giveId: "calculateHeight",
		'$route': function() {
			this.onCreated();
			//this.onMounted();
			this.$forceUpdate(); // to call computed properties
		},
		selectedOwner(newVal, oldVal) {
			// ignore the watcher firing on mount
			if (!this.ownerInitComplete) return

			if (newVal === oldVal) return;
			// now it really is a user-driven change:
			this.assignOwner()
		}
	},
    async created() {
		this.onCreated();
	},
	async mounted() {
		this.onMounted();
	},
	computed: {
		analysisRecommended() {
			return this.analysis && this.analysis.recommended
				? this.analysis.recommended
				: { score: null, reasoning: '' };
		},

		analysisScoreClass() {
			const score = this.analysis && this.analysis.recommended && this.analysis.recommended.score;
			if (score === 'Do Not Approve') return 'analysis-score--rejected';
			if (score === 'Approve with Caution') return 'analysis-score--caution';
			if (score === 'Approve') return 'analysis-score--approved';
			return '';
		},
		getStatus: function () {
			switch (this.status) {
				case '(0) New':
					return 'New';
				case '(1) Tagged':
					return 'Match Request';
				case '(2) Matched':
					return 'Send Request';
				case '(3) Dispatched':
					return 'Active';
				case '(4) Reminded':
					return 'Reminded';
				case '(5) Responded':
					return 'Active';
				case '(6) Feedback added':
					return 'Active';
				case '(6) Feedback requested':
					return 'Active';
				case '(7) Closed':
					return 'Closed';
				case '(8) Rejected':
					return 'Rejected';
				case 'Add Tags':
					return 'Add Tags';
				case 'Review':
					return 'Review';
				case 'In Review':
					return 'In Review';
				case 'Reviewed':
					return 'Reviewed';
				case 'Pending':
					return 'Pending';
			}
		},
		availableInteractions: function () {
			if (this.ask.availableInteractions) {
				let availableInteractions = this.ask.availableInteractions.slice()
				if (this.status !== '(8) Rejected' && this.status !== '(7) Closed' && availableInteractions.indexOf('reject') >= 0) {
					availableInteractions.splice(availableInteractions.indexOf('reject') + 1, 0, "coach");
				}
				availableInteractions.forEach((val, index) => {
					if (val.match(/send-connect-email/i)) {
						availableInteractions[index] = 'send-response';
					} else if (val.match(/resolve/i)) {
						availableInteractions[index] = 'close';
					}
				});
				if (this.status === 'Add Tags') {
					return availableInteractions.filter((interaction) => interaction !== 'edit' && interaction !== 'tag');
				} else if (this.status === '(0) New') {
					return availableInteractions.filter((interaction) => interaction !== 'edit');
				} else if (this.status === '(1) Tagged') {
					return availableInteractions.filter((interaction) => interaction !== 'edit' && interaction !== 'reject');
				} else if (this.status === '(2) Matched') {
					return availableInteractions.filter((interaction) => interaction !== 'edit');
				} else if (this.status === '(3) Dispatched' || this.status === '(4) Reminded') {
					return availableInteractions.filter((interaction) => interaction !== 'send-reminder-email');
				} else if (this.status === '(5) Responded') {
					return availableInteractions.filter((interaction) => interaction !== 'send-response' && interaction !== 'get-feedback' && interaction !== 'send-reminder-email');
				} else if (this.status === '(7) Closed') {
					return availableInteractions.filter((interaction) => interaction !== 'add-feedback');
				} else if (this.status === 'Review' || this.status === 'In Review' || this.status === 'Reviewed') {
					return availableInteractions.filter((interaction) => interaction);
				} else if (this.status === 'Pending') {
					// return availableInteractions.filter((interaction) => interaction);
					return availableInteractions.filter((interaction) => interaction !== 'approve');
				} else {
					return availableInteractions.filter((interaction) => interaction !== 'add-feedback' && interaction !== 'reject');
				}
			}
			return this.ask.availableInteractions;
		},
		sortResponses: function () {
			if (this.ask && this.ask.gives.length) {
				return this.$lodash.orderBy(this.ask.gives, function (o) { return o.when }, ['desc']);
			}
		},
		suggestedAdvisorsList: function () {
			let data = this.suggestedAdvisors.slice(0, this.showSuggestedAdviser);
			return this.$lodash.orderBy(data, ['score'], [this.currentSuggestedSortScore]);
		},
		matchedAdvisorsList: function () {
			let matchedAdvisors = this.matchedAdvisors.slice();
			if (matchedAdvisors.length) {
				return this.$lodash.orderBy(this.matchedAdvisors, ['score'], [this.currentMatchedSortScore])
			}
			return matchedAdvisors;
		},
		formattedText: {
			get() {
				return this.ask && typeof this.ask.text === 'string' ? this.ask.text : '';
			},
			set(value) {
				if (this.ask) this.ask.text = value;
			}
		}
	},
	methods: {
		openAndScrollToResponses() {
			if (!this.opened.includes('response')) {
				this.expand('response'); // ✅ removed the redundant $refs.responseExpandBtn.$el.click()
			}
			this.$nextTick(() => {
				const el = document.getElementById('response-section');
				if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		},
		generateEvaluation: async function (give) {
			this.evaluatingGiveId = give._id;
			try {
				const res = await this.api.post(
					`asks/${this.$route.params.ask_id}/evaluate-response`,
					{
						requestId: this.$route.params.ask_id,
						giveId: give._id,
						response_message: give.insight
					}
				);
				this.$set(give, 'responseEvaluation', res.data);
				this.$toast.success('Evaluation complete.');
			} catch (err) {
				console.error('Evaluation failed:', err);
				this.$toast.error('Evaluation failed. Please try again.');
			} finally {
				this.evaluatingGiveId = null;
			}
		},
		openEvalModal(give) {
			this.selectedEval = give.responseEvaluation;
			this.evalModalOpen = true;
		},
		formatSentimentRaw(rawText) {
			return rawText.replace(/\n/g, '<br>');
		},
		handleGenerateEvaluation: async function () {
			this.athenaLoading = true;
			if (this.$refs.approvalGuidance) {
				this.$refs.approvalGuidance.setLoading(true);
			}
			try {
				await this.api.get(`asks/${this.$route.params.ask_id}/get-athena-analysis`, { params: { message_type: 'request' } });
				await this.loadData();
				if (this.$refs.approvalGuidance) {
					this.$refs.approvalGuidance.setLoading(false);
				}
				this.$toast.success('Analysis completed successfully.');
			} catch (error) {
				console.error('Athena analysis failed:', error);
				if (this.$refs.approvalGuidance) {
					this.$refs.approvalGuidance.setError('Analysis failed. Please try again.');
				}
				this.$toast.error('Analysis failed. Please try again.');
			} finally {
				this.athenaLoading = false;
			}
		},
		getStatusLabel: function (evaluation) {
			const score = evaluation && evaluation.recommended && evaluation.recommended.score;
			if (!score) return 'N/A';
			if (score === 'Approve') return 'PASS';
			if (score === 'Approve with Caution') return 'CAUTION';
			return 'FAIL';
		},
		getStatusClass: function (evaluation) {
			const score = evaluation && evaluation.recommended && evaluation.recommended.score;
			if (!score) return 'text-muted';
			if (score === 'Approve') return 'text-success';
			if (score === 'Approve with Caution') return 'text-warning';
			return 'text-danger';
		},
		toggleEvaluation(id) {
			const idx = this.expandedEvals.indexOf(id);
			if (idx > -1) this.expandedEvals.splice(idx, 1);
			else this.expandedEvals.push(id);
		},
		async onCreated() {
			this.authUser = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')) : {};
			await this.getAllOwners();
			await this.loadData();
			this.status = this.ask.status;
			var action = this.$route.query.action;
			if (this.$route.query.action) {
				if (action === 'Add Tags' && this.status === '(0) New' || action === 'Add Tags' && this.status === '(1) Tagged' || action === 'Add Tags' && this.status === 'Reviewed') {
					this.status = 'Add Tags';
				} else if (action === 'review') {
					this.status = 'Review';
					this.doInteraction(action);
				} else {
					this.doInteraction(action);
				}
			}
			this.loaded = true;
		},
		async onMounted() {
			var textarea = $('#textarea');
			var div = $('<div id="temp"></div>');
			div.text(textarea.val()).css({ 'overflow-wrap': 'break-word', 'white-space': 'pre-line' });
			$('body').append(div);
			var divHeight = $('#temp').height();
			if (divHeight > 155) {
				textarea.css({ height: divHeight + 10 });
			}
			div.remove();
		},
		sanitizeRequestSupport(value) {
			this.requestSupportMsg = sanitizeInput(value);
		},
		sanitizeCoachMsg(value) {
			this.coachMsg = sanitizeInput(value);
		},
		sanitizeSubject(value) {
			this.ask.subject = sanitizeInput(value);
		},
		sanitizeDescription(e) {
			this.ask.text = sanitizeInput(e.target.value);
		},
		sanitizeTags(value) {
			this.tags = sanitizeInput(value);
		},
		sanitizeSearchAdvisors(value) {
			this.searchAdvisors = sanitizeInput(value);
		},
		sanitizeFollowUpMessage(e, index) {
			this.followUpMessage[index] = sanitizeInput(e.target.value);
		},
		sanitizeResponseInsight(e) {
			this.responseInsight = sanitizeInput(e.target.value);
		},
		sanitizeInsight(e, give) {
			give.insight = sanitizeInput(e.target.value);
		},
		async loadData() {
			this.analysis = null;
			this.responseSectionCount = 0;
			await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
			  	if (ask.data instanceof Object || ask.data instanceof Array) {
					  this.ask = ask.data;
					  this.getAdvList();
					  this.selectedOwner = this.ask.reserveOwner && this.ask.reserveOwner.email ? this.ask.reserveOwner.email : '';
					  const found = await this.allOwners.some(el => el.email === this.selectedOwner);
					  if (!found) {
						this.selectedOwner = '';
					  }
					  this.reserveStatus = this.ask.reserve;
					  if (this.ask.reserve) {
						  this.reserveTxt = 'Reserved';
					  }
					  this.reserveBtn = true;
					  this.status = this.ask.status;
					  this.escalateBtn = true;
					if (this.ask && this.ask.community) {
						this.community = this.ask.community;
						this.community.administrators.map(singleAdmin => {
							if (this.newAdmin.indexOf(singleAdmin.memberId) < 0) {
								this.newAdmin.push(singleAdmin.memberId);
							}
						})
						if (this.$lodash.has(this.community, 'customSettings')) {
							this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
							this.communityStyle.color = this.community.customSettings.secondaryColor;
						}
						if (this.ask && this.ask.community && this.ask.community.content && this.ask.community.content.coach) {
							this.coachMsg = this.ask.community.content.coach;
						}
					}
					if (this.$route.query.viewRequest) {
						this.$gtm.enable(true)
						this.$gtm.trackEvent({
							'RequestID': this.ask._id,
							'RequestSource': 'Web',
							'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
							'Community': this.ask.community.name,
							'event': 'SuperUserView'
						});
						var newRouteQuery = this.$lodash.omit(this.$route.query, 'viewRequest');
						this.$router.replace({ query: newRouteQuery });
					}

					if (this.ask.reserveOwner && this.ask.reserveOwner.email) {
						this.isReserveOwner = true;
					}
					this.ownerInitComplete = true
			  	}
		  	});
		  	if (!this.ask) return;

			if (this.ask.analysis) {
				this.analysis = this.ask.analysis;
			} else if (this.ask.requestEvaluation) {
				this.analysis = this.ask.requestEvaluation;
			}

			await this.getFeedbacks();

			this.responseSectionCount += this.ask.gives.filter(
				({ helpaction, responseState }) =>
					helpaction === 'yes' && responseState.currentState === 'Approved'
			).length;

			try {
				if (this.ask.community.matching.taxonomyMatching === true) {
					await this.api.post(`members/suggestion-tag`, {text: this.ask.text}).then(tags => {
						if (tags.data) {
							this.suggestedTags = tags.data;
						}
					});
				} else {
					await axios.post(
		              `https://language.googleapis.com/v1/documents:analyzeEntities?fields=entities&key=${
		                process.env.NLP_API_KEY
		              }`,
		              {
		                document: {
		                  content: this.ask.text,
		                  language: "en",
		                  type: "PLAIN_TEXT"
		                },
		                encodingType: "UTF16"
		              }
		            )
		            .then(nlp => {
		              	var entities = nlp.data.entities;
		              	entities = this.$lodash.uniqBy(entities, 'name');
					  	entities.map(entity => {
		                	if (this.suggestedTags.indexOf(entity.name) === -1) {
								this.suggestedTags.push(entity.name);
							}
		              	});
					});
				}
			} catch (err) {
				console.error('Suggested tags lookup failed:', err);
			}
		},
		getFeedbacks: async function() {
			await this.api.get(`asks/${this.$route.params.ask_id}/feedbacks`).then(feedback => {
				this.feedbacks = feedback.data;
			});
		},
		async getAsk() {
			await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
				if (ask.data instanceof Object || ask.data instanceof Array) {
					this.ask = ask.data;
					console.log(this.ask);
					if (this.ask.analysis) {
						this.analysis = this.ask.analysis;
					} else if (this.ask.requestEvaluation) {
						this.analysis = this.ask.requestEvaluation;
					} else {
						this.analysis = null;
					}
					this.reserveStatus = this.ask.reserve;
					if (this.ask.reserve) {
						this.reserveTxt = 'Reserved';
					}
					this.reserveBtn = true;
					this.status = this.ask.status;
					this.escalateBtn = true;
				}
			});
		},
		async getAdvList() {
			this.sugAdvLimit = 5;
			this.sugAdvSkip = 0;
			this.sugAdvCount = 0;
			await this.api.get(`asks/${this.$route.params.ask_id}/advisor-list/?limit=${this.sugAdvLimit}&skip=${this.sugAdvSkip}&isDisplayScore=no`).then(async advList => {
				this.matchedAdvisors = advList.data.adviserList;
				this.suggestedAdvisors = advList.data.suggestedAdvisers.list;
				this.sugAdvCount = advList.data.suggestedAdvisers.count;
				this.respondedMember = advList.data.respondedMember;
			});
		},
		async refreshBtn () {
			this.matchAdviserList(this.page);
		},
		async goToPage() {
			this.matchAdviserList(this.page);
		},
		cancelRequestSupport: function() {
			this.requestSupportMsg = '';
			this.showDialog = false;
		},
		cancelCoach: function() {
			if (this.ask && this.ask.community && this.ask.community.content && this.ask.community.content.coach) {
				this.coachMsg = this.ask.community.content.coach;
			} else {
				this.coachMsg = ""
			}
			this.coachDialog = false;
		},
		async matchAdviserList (pageNum) {
			this.page = pageNum;
			this.sugAdvScoreSkip = pageNum * this.sugAdvScoreLimit;
			if (pageNum === 1) {
				this.sugAdvScoreSkip = 0 * this.sugAdvScoreLimit;
			} else {
				this.sugAdvScoreSkip = (pageNum - 1) * this.sugAdvScoreLimit;
			}
			this.getAllAdvList();
  		},
		async getAllAdvList() {
			this.isDisplayScore = 'yes';
			await this.api.get(`asks/${this.$route.params.ask_id}/advisor-list/?limit=${this.sugAdvScoreLimit}&skip=${this.sugAdvScoreSkip}&isDisplayScore=yes&adviserType=${this.suggestedAdvisorType}&search=${this.searchAdvisors}`).then(async advList => {
				let totalPage = advList.data.suggestedAdvisers.count / this.sugAdvScoreLimit;
				this.pageCount = Math.ceil(totalPage);
				if (this.pageCount > 0) {
					this.isMatchBtnShow = false;
				}
				this.matchedAdvisors = advList.data.adviserList;
				this.suggestedAdvisors = advList.data.suggestedAdvisers.list;
				this.respondedMember = advList.data.respondedMember;
				this.adviserMatchSection = true;
				this.expandSuggestedAdviser = [];
				this.expand('adviser-match')
				this.sortMatchedAdviser('desc', 'score');
				this.sortSuggestedAdviser('desc', 'score');
			});
		},
		sugAdvData(type, sort = '', sortType = '') {
			if (type === 'loadMore') {
				this.sugAdvSkip = this.sugAdvSkip + this.sugAdvLimit;
			} else {
				if (sortType === 'score') {
					this.currentSuggestedSortScore = sort;
				} else if (sortType === 'community') {
					this.currentSuggestedSortCommunity = sort;
				} else if (sortType === 'last_request') {
					this.currentSuggestedSortLastReqRec = sort;
				} else if (sortType === 'frequency') {
					this.currentSuggestedSortFreq = sort;
				} else if (sortType === 'last_response') {
					this.currentSuggestedSortLastResponse = sort;
				}
				this.sort = sort;
				this.sortType = sortType;
				this.sugAdvLimit = 5;
				this.sugAdvSkip = 0;
				this.sugAdvCount = 0;
			}
			if ((this.sugAdvSkip < this.sugAdvCount) || type === 'sort') {
				var advList = this.ask.recommendedAdvisors.map(adviser => adviser);
				this.api.get(`asks/${this.$route.params.ask_id}/get-suggested-advisor`, {params: {adviserIdArr: advList, ask: this.ask._id, limit: this.sugAdvLimit, skip: this.sugAdvSkip, isDisplayScore: 'no', sort: this.sort, sortType: this.sortType}}).then(adv => {
					if (adv.data instanceof Object || adv.data instanceof Array) {
						this.sugAdvCount = adv.data.count;
						if (type === 'loadMore') {
							this.suggestedAdvisors = [...this.suggestedAdvisors, ...adv.data.data];
						} else {
							this.suggestedAdvisors = adv.data.data;
						}
					}
				});
			}
		},
    	async addSuggested(tagExist) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				tagExist = tagExist.replace(' (Organization)', '');
				tagExist = tagExist.replace(' (Roles)', '');
				tagExist = tagExist.replace(' (Education)', '');
				tagExist = tagExist.replace(' (Location)', '');
				tagExist = tagExist.replace(' (Skills)', '');
				var checkTag = this.ask.tags.filter((tag) => tag.trim().toLowerCase() === tagExist.trim().toLowerCase());
				if (!checkTag.length) {
					this.ask.tags.push(tagExist);
					// auto save on add suggested
					await this.api
					.post(`asks/${this.ask._id}/request/tag`, {
						tags: this.ask.tags
					}).then(nlp => {
						this.sortMatchedAdviser('desc', 'score');
						this.sortSuggestedAdviser('desc', 'score');
					});
				}
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
    	},
    	async addTags($event) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				if ($event.target[0].value) {
	    			let checkTag = this.ask.tags.filter((tag) => tag.toLowerCase() === $event.target[0].value.toLowerCase().trim());
					if (!checkTag.length) {
	    				this.ask.tags.push($event.target[0].value.trim());
	    				this.tags = '';
						// auto save on add tags input
						await this.api
						.post(`asks/${this.ask._id}/request/tag`, {
							tags: this.ask.tags
						}).then(async() => {
							this.sortMatchedAdviser('desc', 'score');
							this.sortSuggestedAdviser('desc', 'score');
						});
	    			}
	    		}
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		expand(id) {
			if (id === 'adviser-match') {
				this.sortMatchedAdviser('desc', 'score');
				this.sortSuggestedAdviser('desc', 'score');
			}
			const index = this.opened.indexOf(id);
			if (index !== -1) {
				this.opened.splice(index, 1); // ✅ was: splice(index, id)
			} else {
				this.opened.push(id);
			}
		},
		async removeTag(tag) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				var index = this.ask.tags.indexOf(tag);
	    		if (index !== -1) {
	    			this.ask.tags.splice(index, 1);
					// auto save on remove tag
					await this.api
					.post(`asks/${this.ask._id}/request/tag`, {
						tags: this.ask.tags
					}).then(async () => {
						this.sortMatchedAdviser('desc', 'score');
						this.sortSuggestedAdviser('desc', 'score');
					});
	    		}
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
    	},
		async saveTag() {
			if (this.ask && this.ask.tags && this.ask.tags.length) {
				await this.api
				.post(`asks/${this.ask._id}/tag`, {
					tags: this.ask.tags
				})
				.then(response => {
					this.$emit("reload");
					this.getAsk();
					this.reserveStatus = false;
					this.reserveTxt = 'Reserve';
					this.status = response.data.status;
					this.sortMatchedAdviser('desc', 'score');
					this.sortSuggestedAdviser('desc', 'score');
				});
			} else {
				Vue.$toast.error('Please add some tag in tag section');
			}
		},
		async saveTagInSection() {
			await this.api
			.post(`asks/${this.ask._id}/request/tag`, {
				tags: this.ask.tags
			});
		},
    	async doInteraction(action) {
			if (action === 'coach') {
				this.coachDialog = true;
			} else if (action === 'reject') {
					await this.api
					.post(`asks/${this.ask._id}/request/${action}`)
					.then(response => {
						this.$emit("reload");
						this.getAsk();
						this.$router.replace(`/asks/${this.ask._id}/request`);
					});
			} else {
					if (this.status === '(7) Closed') {
						if (action === 'reopen') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.getAsk();
							});
						}
						return;
					}
					if (action === 'close') {
						await this.api
						.post(`asks/${this.ask._id}/resolve`)
						.then(response => {
							this.$emit("reload");
							this.getAsk();
							this.reserveStatus = false;
							this.reserveTxt = 'Reserve';
							this.$router.replace(`/asks/${this.ask._id}/request`)
						});
						return;
					}
					if (action === 'comment') {
						this.expand('comment');
						this.scrollToEle($("#commentDivSection").position().top);
					}
					if (action === 'match' && this.status === 'Add Tags') {
						this.expand('adviser');
						this.scrollToEle($(".adviser-section").position().top);
					}
					if (this.status === 'Pending') {
						if (action === 'approve') {
							await this.api
							.post(`asks/update-request-status`, {askId: this.ask._id, status: 'approve', 'from': 'web'})
							.then(response => {
								this.$emit("reload");
								this.getAsk();
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
								this.$router.replace(`/asks/${this.ask._id}/request`);
							});
						} else if (action === 'reject') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.getAsk();
								this.$router.replace(`/asks/${this.ask._id}/request`);
							});
						}
					}
					if (this.status === '(0) New') {
						if (action === 'reject') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.getAsk();
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
							});
						} else if (action === 'tag') {
							this.status = 'Add Tags';
						} else if (action === 'comment') {
							this.expand(action);
						} else if (action === 'review') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.getAsk();
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
							});
						} else {
							this.$router.push(`/asks/${this.ask._id}/${action}`);
						}
					}
					if (this.status === '(1) Tagged') {
						if (action === 'tag') {
							this.status = 'Add Tags';
							this.reserveStatus = false;
							this.reserveTxt = 'Reserve';
						} else if (action === 'match') {
							this.expand('adviser');
							this.scrollToEle($(".adviser-section").position().top);
						}
					}
					if (this.status === '(2) Matched') {
						if (action === 'match') {
							this.expand('adviser');
							this.scrollToEle($(".adviser-section").position().top);
						} else if (action === 'send-request') {
							setTimeout(() => {
							}, 500);
							var recipients = this.ask.advisorFlags.reduce((result, advisorFlag) => {
								if (advisorFlag.flag === 0 && typeof advisorFlag.firstRequestSent === 'undefined') {
									result.push(advisorFlag.advisor);
								}
								return result;
							}, []);
							if (recipients.length) {
								await this.api
								.post(`asks/${this.ask._id}/request/${action}`, {recipients: recipients})
								.then(response => {
									this.$emit("reload");
									if (response.data.success && response.data.success == true &&
										typeof response.data.isAdvisorMatched != "undefined" && response.data.isAdvisorMatched == false) {
										Vue.$toast.warning('No adviser matched');
									}
									this.getAsk();
									this.reserveStatus = false;
									this.reserveTxt = 'Reserve';
								});
							} else {
								Vue.$toast.warning('No adviser matched');
							}
						}
					}
					if (this.status === '(3) Dispatched') {
						if (action === 'send-request') {
							var recipientsFirstMail = this.ask.advisorFlags.reduce((result, advisorFlag) => {
								// if (advisorFlag.flag === 0 && (typeof advisorFlag.firstRequestSent === 'undefined' || typeof advisorFlag.firstRequestSent === 'string')) {
								if (advisorFlag.flag === 0 && typeof advisorFlag.firstRequestSent === 'undefined') {
									result.push(advisorFlag.advisor);
								}
								return result;
							}, []);
							if (recipientsFirstMail.length) {
								await this.api
								.post(`asks/${this.ask._id}/request/${action}`, {recipients: recipientsFirstMail})
								.then(response => {
									this.$emit("reload");

									if (response.data.success && response.data.success == true &&
										typeof response.data.isAdvisorMatched != "undefined" && response.data.isAdvisorMatched == false) {
										Vue.$toast.warning('No adviser matched');
									}
									this.getAsk();
									this.reserveStatus = false;
									this.reserveTxt = 'Reserve';
								});
							} else {
								Vue.$toast.warning('No adviser matched');
							}
						} else if (action === 'respond') {
							this.expand('response');
							this.scrollToEle($("#response-section").position().top);
						}
					}
					if (this.status === '(4) Reminded') {
						if (action === 'respond') {
							this.expand('response');
							this.scrollToEle($("#response-section").position().top);
						} else if (action === 'send-request') {
							var recipientsFirstMailReminded = this.ask.advisorFlags.reduce((result, advisorFlag) => {
								if (advisorFlag.flag === 0 && typeof advisorFlag.firstRequestSent === 'undefined') {
									result.push(advisorFlag.advisor);
								}
								return result;
							}, []);
							if (recipientsFirstMailReminded.length) {
								await this.api
								.post(`asks/${this.ask._id}/request/${action}`, {recipients: recipientsFirstMailReminded})
								.then(response => {
									this.$emit("reload");
									this.getAsk();
									this.reserveStatus = false;
									this.reserveTxt = 'Reserve';
								});
							} else {
								Vue.$toast.warning('No adviser matched');
							}
						}
					}
					if (this.status === '(5) Responded' || '(6) request-feedback' || '(6) feedback added') {
						if (action === 'respond') {
							this.expand('response');
							this.scrollToEle($("#response-section").position().top);
						} else if (action === 'send-first-email') {
							var recipientsFirstMail1 = this.ask.advisorFlags.reduce((result, advisorFlag) => {
								if (advisorFlag.flag === 0 && typeof advisorFlag.firstRequestSent === 'undefined') {
									result.push(advisorFlag.advisor);
								}
								return result;
							}, []);
							if (recipientsFirstMail1.length) {
								await this.api
								.post(`asks/${this.ask._id}/request/${action}`, {recipients: recipientsFirstMail1})
								.then(response => {
									this.$emit("reload");
									this.reserveStatus = false;
									this.reserveTxt = 'Reserve';
									this.status = response.data.status;
									this.getAsk();
								});
							} else {
								Vue.$toast.warning('No adviser matched');
							}
						}
					}
					if (this.status === '(8) Rejected') {
						if (action === 'reopen') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
								this.getAsk();
							});
						}
					}
					if (this.status === 'Review') {
						await this.api
						.post(`asks/${this.ask._id}/request/${action}`)
						.then(response => {
							this.$emit("reload");
							this.status = response.data.status;
							this.getAsk();
							this.reserveStatus = false;
							this.reserveTxt = 'Reserve';
							this.$router.replace(`/asks/${this.ask._id}/request`)
						});
					}
					if (this.status === 'In Review') {
						if (action === 'approve') {
							this.AdminApprovalDialog = true;
						} else if (action === 'reject') {
							await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
								this.ask = ask.data;
								this.ask.status = ask.data.status;
								if ((ask.data instanceof Object || ask.data instanceof Array) && ask.data.status === 'In Review') {
									await this.api.post(`asks/${this.ask._id}/request/${action}`).then(response => {
										this.$emit("reload");
										this.getAsk();
										this.$router.replace(`/asks/${this.ask._id}/request`);
									});
								}
							});
						}
					}
					if (this.status === 'Reviewed') {
						if (action === 'tag') {
							this.status = 'Add Tags';
						} else if (action === 'reject') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
								this.getAsk();
								this.$router.replace(`/asks/${this.ask._id}/request`);
							});
						}
					}
					if (this.status === 'Add Tags') {
						if (action === 'reject') {
							await this.api
							.post(`asks/${this.ask._id}/request/${action}`)
							.then(response => {
								this.$emit("reload");
								this.getAsk();
								this.reserveStatus = false;
								this.reserveTxt = 'Reserve';
							});
						}
					}
				}
		},
		async AdminApproval() {
			this.AdminApprovalDialog = false;
			await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
				this.ask = ask.data;
				this.ask.status = ask.data.status;
				if ((ask.data instanceof Object || ask.data instanceof Array) && ask.data.status === 'In Review') {
					await this.api.post(`asks/${this.ask._id}/request/approve`).then(async response => {
						this.$emit("reload");
						this.status = this.ask.status;
						if (this.community.settings.matching === 'Automated') {
							this.autoMatching();
						}
						setTimeout(() => {
							this.getAsk();
						}, 500);
						this.reserveStatus = false;
						this.reserveTxt = 'Reserve';
						this.$router.replace(`/asks/${this.ask._id}/request`);
					});
				}
			});
		},
    	async reject() {
    		await this.api
	        .post(`asks/${this.ask._id}/${this.action}`, {
	          comment: this.comment,
	          recipients: this.newAdmin
	        })
	        .then(response => {
	          this.$emit("reload");
	        });
    	},
		async saveAskContent(fieldName) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				if (fieldName === 'subject' && this.ask.subject && this.ask.subject.length) {
					await this.api.put(`asks/${this.$route.params.ask_id}`, {subject: this.ask.subject}).then(async ask => {
						if (ask.data instanceof Object || ask.data instanceof Array) {
							let tempAskCreatedMemberData = this.ask.createdByMemberID;
							this.ask = ask.data;
							if (typeof ask.data.createdByMemberID == 'string') {
								this.ask.createdByMemberID = tempAskCreatedMemberData;
							}
						}
					});
				}
				if (fieldName === 'description' && this.ask.text && this.ask.text.length) {
					await this.api.put(`asks/${this.$route.params.ask_id}`, {text: this.ask.text}).then(async ask => {
						if (ask.data instanceof Object || ask.data instanceof Array) {
							let tempAskCreatedMemberData = this.ask.createdByMemberID;
							this.ask = ask.data;
							console.log('TEXT', this.ask.text);
							console.log('PROMPT', this.ask.prompt)
							if (typeof ask.data.createdByMemberID == 'string') {
								this.ask.createdByMemberID = tempAskCreatedMemberData;
							}
						}
					});
				}
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		getAdviserDetails: function(field, Id, giveId = '') {
			var memberLst = this.matchedAdvisors.concat(this.suggestedAdvisors);
			memberLst = memberLst.concat(this.respondedMember);
			if (field === 'request-date') {
				let member = memberLst;
				if (member.length && field === 'request-date') {
				let give = this.ask.gives.filter(give => give._id === giveId);
				if (give.length && give[0].helpaction === 'yes' && give[0].responseState.currentState === 'Approved' && give[0].action && ['Insight', 'Share Advice'].includes(give[0].action.toString()) && give[0].responseSentDate) {
						return this.$moment(give[0].responseSentDate).tz("America/New_York").format('MM/DD/YYYY HH:mm');
					} else if (give.length && give[0].helpaction === 'yes' && give[0].action && ['Call Me', 'Let\'s Connect'].includes(give[0].action.toString()) && give[0].responseSentDate) {
						return this.$moment(give[0].responseSentDate).tz("America/New_York").format('MM/DD/YYYY HH:mm');
					} else if (give.length && give[0].helpaction === 'no') {
						return 'N/A';
					} else {
						return 'N/A';
					}
				}
			}
			let member = memberLst.filter(member => member._id === Id);
			if (member.length && field === 'name') {
				if (member[0].name) {
                    return member[0].name;
                } else if (member[0].email && member[0].email.length) {
                    return member[0].email[0];
                } else if (member[0].displayName) {
                	return member[0].displayName;
                } else if (member[0].emails && member[0].emails.length) {
                	return member[0].emails[0];
                }
			} else if (member.length && field === 'email') {
                if (member[0].email && member[0].email.length) {
                    return member[0].email;
                } else if (member[0].emails && member[0].emails.length) {
                	return member[0].emails[0];
                }
			} else if (member.length && field === 'community') {
                if (member[0].community) {
                    return member[0].community;
                } else {
					return 'N/A';
				}
			} else {
				return 'N/A';
			}
		},
		expandResponseSection(id) {
    		var index = this.expandResponse.indexOf(id);
    		if (index !== -1) {
    			this.expandResponse.splice(index, 1);
    		} else {
    			this.expandResponse.push(id);
    		}
    	},
		expandAdviserSection(id) {
    		var index = this.expandAdviser.indexOf(id);
    		if (index !== -1) {
    			this.expandAdviser.splice(index, 1);
    		} else {
    			this.expandAdviser.push(id);
    		}
    	},
		expandSuggestedAdviserSection(id) {
    		var index = this.expandSuggestedAdviser.indexOf(id);
    		if (index !== -1) {
    			this.expandSuggestedAdviser.splice(index, 1);
    		} else {
    			this.expandSuggestedAdviser.push(id);
    		}
    	},
		sendFeedbackToMember: async function(give) {
			if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
				let advisorId = give.advisors[0];
				let adviserEmail = give.email;
				await this.api.post(`asks/${this.$route.params.ask_id}/request/send-feedback-member`, {give: give._id, type: 'feedback-member', advisorId: advisorId, adviserEmail: adviserEmail}).then(response => {
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		sendResponseToMember: async function(give) {
			if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
				await this.api.post(`asks/${this.$route.params.ask_id}/request/send-response-member`, {give: give._id, type: 'response-member'}).then(response => {
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		async addAdvisors(members) {
			await this.api.get(`members/${members[0]}`).then(member => {
				this.advisers = member.data;
				if (member.data.first && member.data.last) {
					this.adviserName = member.data.first + ' ' + member.data.last;
				} else if (member.data.emails && member.data.emails.length) {
					this.adviserName = member.data.emails[0];
				}
			});
		},
		async addManualResponse(event) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				this.$validator.validateAll().then(async result => {
					var validate = this.validateAdviser1();
					if (result && validate) {
						await this.api.post(`asks/${this.$route.params.ask_id}/request/respond`, {advisers: [this.advisers._id], insight: this.responseInsight}).then(ask => {
							this.$emit("reload");
							this.loadData();
							this.reserveStatus = false;
							this.reserveTxt = 'Reserve';
							this.advisers = {};
							this.adviserName = '';
							this.responseInsight = '';
							event.target.reset();
							this.$validator.reset()
						});
					}
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		goToProfile: function(Id) {
			let route = this.$router.resolve({path: `/members/${Id}`});
			window.open(route.href, '_blank');
		},
		validateAdviser1: function() {
			if (this.$lodash.has(this.advisers, '_id')) {
				this.adviserNameError = '';
				return true;
			}
			this.adviserNameError = 'Please select adviser';
			return false;
		},
		setFrequency: function(freq) {
			var data = '';
			this.availableFrequncy.filter((obj) => {
				return Object.keys(obj).some((key) => {
					if (key.toLowerCase() === freq.toLowerCase()) {
						data = obj[key];
						return false;
					} else {
						if (/once a week/.test(key)) {
							data = obj[key];
							return false;
						}
					}
					return false;
				})
			});
			return data;
    	},
		getAdviserSectionStatus: function(adviserId) {
			let giveData = [];
			if (this.ask) {
				let give = this.ask.gives.filter(give => {
					if (give.advisors && give.advisors.length && give.advisors[0] === adviserId) {
						return give;
					}
				});
				if (give && give.length) {
					giveData.push(give[give.length - 1]);
				}
				let advisorData = this.ask.advisorFlags.filter(advisorFlag => advisorFlag.advisor === adviserId);
				let feedbackData = this.ask.feedbackAdvisorFlags.filter(feedbackAdvisorFlag => feedbackAdvisorFlag.advisor === adviserId);
				if (advisorData && advisorData.length && advisorData[0].flag === 0 && typeof advisorData[0].firstRequestSent === 'undefined') {
					return '-';
				} else if (advisorData && advisorData.length && advisorData[0].flag === 0 && advisorData[0].firstRequestSent) {
					return 'Requested';
				} else if (advisorData && advisorData.length && advisorData[0].flag === 1) {
					return '1st Reminder';
				} else if (advisorData && advisorData.length && advisorData[0].flag === 2) {
					return '2nd Reminder';
				} else if (!feedbackData.length && advisorData && advisorData.length && advisorData[0].flag === 3 && giveData.length && giveData[0].helpaction === 'yes') {
					return 'Responded';
				} else if (advisorData && advisorData.length && advisorData[0].flag === 5) {
					return 'Reminder';
				} else if (giveData.length && giveData[0].helpaction && giveData[0].helpaction === 'no') {
					return 'Declined';
				} else if (feedbackData && feedbackData.length && feedbackData[0].flag === 1) {
					return 'Requested Feedback';
				} else if (feedbackData && feedbackData.length && feedbackData[0].flag === 2) {
					return '1st Feedback Reminder';
				} else if (feedbackData && feedbackData.length && feedbackData[0].flag === 3) {
					return 'Feedback';
				} else {
					return 'N/A';
				}
			}
		},
		async addToMatchedAdviser(suggestedAdvisor, index) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				await this.api.put(`asks/${this.$route.params.ask_id}/request/match-adviser`, {adviser: suggestedAdvisor._id}).then(result => {
					if (result && result.data && result.data.unsubscribed == false) {
						if (this.suggestedAdvisors && this.suggestedAdvisors.length && index !== -1) {
							var finalIndex = this.findAdvisorIndexFromList(this.suggestedAdvisors, suggestedAdvisor._id);
							this.getAsk();
							this.status = result.data.ask.status;
							this.matchedAdvisors.push(this.suggestedAdvisors[finalIndex]);
							this.suggestedAdvisors.splice(finalIndex, 1);
							this.$emit("reload");
						}
					} else {
						this.$toast.error('You can not add this advisor, because the advisor was unsubscribed from the system.');
					}
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		async removeFromMatchedAdviser(matchedAdvisor, index) {
			if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				await this.api.put(`asks/${this.$route.params.ask_id}/request/unmatch-adviser`, {adviser: matchedAdvisor._id}).then(result => {
					if (this.matchedAdvisors && this.matchedAdvisors.length && index !== -1) {
						var finalIndex = this.findAdvisorIndexFromList(this.matchedAdvisors, matchedAdvisor._id);
						this.suggestedAdvisors.push(this.matchedAdvisors[finalIndex]);
						this.matchedAdvisors.splice(finalIndex, 1);
						this.getAsk();
					}
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		findAdvisorIndexFromList(fromAdvisorList, findIndex) {
			var finalIndex = "";
			fromAdvisorList.map((adviser, fIndex) => {
				if (adviser._id === findIndex) {
					finalIndex = fIndex;
				}
			});
			return finalIndex;
		},
		rematchAdviserSection(type) {
			this.showSuggestedAdviser = 5;
			this.currentMatchedSortScore = 'desc';
			this.currentSuggestedSortScore = 'desc';
			this.sugAdvScoreSkip = 0;
			this.sugAdvScoreLimit = 2300;
			this.suggestedAdvisorType = type;
			this.getAllAdvList();
			this.page = 1;
		},
		sortMatchedAdviserScore(sorting) {
			if (this.matchedAdvisors.length) {
				this.currentMatchedSortScore = sorting;
				this.matchedAdvisors = this.$lodash.orderBy(this.matchedAdvisors, ['score'], [sorting]);
			}
		},
		async sortMatchedAdviser(sorting, field) {
			if (this.matchedAdvisors.length) {
				if (field === 'score') {
					this.currentMatchedSortScore = sorting;
				} else if (field === 'community') {
					this.currentMatchedSortCommunity = sorting;
				} else if (field === 'last_request') {
					this.currentMatchedSortLastReqRec = sorting;
				} else if (field === 'frequency') {
					this.currentMatchedSortFreq = sorting;
				} else if (field === 'last_response') {
					this.currentMatchedSortLastResponse = sorting;
				}
				if (field === 'community') {
					this.sortCICommunity(sorting, this.matchedAdvisors);
				} else if (field === 'last_request') {
					this.sortLastRequest(sorting, this.matchedAdvisors);
				} else if (field === 'last_response') {
					this.sortLastResponse(sorting, this.matchedAdvisors);
				} else {
					this.matchedAdvisors = this.$lodash.orderBy(this.matchedAdvisors, [field], [sorting]);
				}
			}
		},
		sortLastRequest: function (sorting, sortFor) {
			var alphabetically = function (ascending) {
				return function (a, b) {
					if (ascending) {
						return a.last_request < b.last_request ? -1 : 1;
					} else if (!ascending) {
						return a.last_request < b.last_request ? 1 : -1;
					}
				};
			}
			if (sorting === 'asc') {
				sortFor.sort(alphabetically(true));
			} else {
				sortFor.sort(alphabetically(false));
			}
        },
		sortLastResponse: function (sorting, sortFor) {
			var alphabetically = function (ascending) {
				return function (a, b) {
					if (ascending) {
						return a.last_response < b.last_response ? -1 : 1;
					} else if (!ascending) {
						return a.last_response < b.last_response ? 1 : -1;
					}
				};
			}
			if (sorting === 'asc') {
				sortFor.sort(alphabetically(true));
			} else {
				sortFor.sort(alphabetically(false));
			}
        },
		sortSuggestedAdviserScore(sorting) {
			if (this.suggestedAdvisors.length) {
				this.currentSuggestedSortScore = sorting;
				this.suggestedAdvisors = this.$lodash.orderBy(this.suggestedAdvisors, ['score'], [sorting]);
			}
		},
		sortSuggestedAdviser(sorting, field) {
			if (this.suggestedAdvisors.length) {
				if (field === 'score') {
					this.newCurrentSuggestedSortScore = sorting;
				} else if (field === 'community') {
					this.newCurrentSuggestedSortCommunity = sorting;
				} else if (field === 'last_request') {
					this.newCurrentSuggestedSortLastReqRec = sorting;
				} else if (field === 'member_rank') {
					this.newCurrentSuggestedSortMemberRank = sorting;
				} else if (field === 'frequency') {
					this.newCurrentSuggestedSortFreq = sorting;
				} else if (field === 'last_response') {
					this.newCurrentSuggestedSortLastResponse = sorting;
				}
				if (field === 'community') {
					this.sortCICommunity(sorting, this.suggestedAdvisors);
				} else if (field === 'last_request') {
					this.sortLastRequest(sorting, this.suggestedAdvisors);
				} else if (field === 'last_response') {
					this.sortLastResponse(sorting, this.suggestedAdvisors);
				} else {
					this.suggestedAdvisors = this.$lodash.orderBy(this.suggestedAdvisors, [field], [sorting]);
				}
			}
		},
		sortCICommunity(sorting, sortFor) {
			var narr = sortFor.sort(function (a, b) {
				var aval = '';
				var bval = '';
					aval = a.community;
					bval = b.community;
				if (sorting === 'asc') {
					return aval.toLowerCase().localeCompare(bval.toLowerCase());
				} else {
					return bval.toLowerCase().localeCompare(aval.toLowerCase());
				}
			});
			sortFor = narr;
		},
		suggestedAdvisorsListWatcher: function() {
			this.suggestedAdvisors = this.$lodash.orderBy(this.suggestedAdvisors, ['score'], [this.currentSuggestedSortScore]);
			let data = this.suggestedAdvisors.slice(0, this.showSuggestedAdviser);
			return this.$lodash.orderBy(data, ['score'], [this.currentSuggestedSortScore]);
		},
		matchedAdvisorsListWatcher: function() {
			this.matchedAdvisors = this.$lodash.orderBy(this.matchedAdvisors, ['score'], [this.currentMatchedSortScore]);
			let matchedAdvisors = this.matchedAdvisors.slice();
			if (matchedAdvisors.length) {
				return this.$lodash.orderBy(this.matchedAdvisors, ['score'], [this.currentMatchedSortScore])
			}
			return matchedAdvisors;
		},
		async addComment($event) {
			// if (this.status !== '(8) Rejected' && this.status !== '(7) Closed') {
				if ($event.target[0].value) {
					var commentVal = $event.target[0].value;
					await this.api.post(`asks/${this.ask._id}/comment`, { comment: commentVal, recipients: this.newAdmin }).then(async response => {
						this.$emit("reload");
						this.reserveStatus = false;
						this.reserveTxt = 'Reserve';
						await this.loadData();
						$event.target.reset();
					});
	    		}
			// } else {
			// 	// console.log("this.community :", this.ask.community);
			// 	let closeMessage = this.ask.community.content.closeRequestMessage;
			// 	this.$toast.error(closeMessage);
			// }
		},
		scrollToEle(scrollPos) {
			const vs = this.$root.$children[0].$children[0].$refs['vs'];
			const y = scrollPos;
			vs.scrollTo({
				y
			});
		},
		editResponse: async function(askId, give) {
            if (give.insight && give.insight.length) {
                await this.api.put(`asks/${askId}/request/edit-give`, {give: give._id, insight: give.insight}).then(response => {
                    this.loadData();
                });
            }
        },
		calculateHeight() {
            if (this.expandResponse.includes(this.giveId) === true) {
                this.$nextTick(() => {
                    let give = $('.response-description').attr('data-id');
                    if (give && give.match(/response-id/i)) {
                        let content = $(`#${give}`).val();
                        var div = $('<div id="temp"></div>').text(content).css({'display': 'none', 'overflow-wrap': 'break-word', 'white-space': 'pre-line'});
                        $('body').append(div);
                        var divHeight = div.height();
                        $(`#${give}`).css({
                            height: divHeight + 10
                        });
                        div.remove();
                    }
                });
            }
        },
		responseActions: async function(askId, giveId, action) {
			if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
	            await this.api.post(`asks/${askId}/response-actions`, {giveId: giveId, action: action}).then((response) => {
	                this.loadData();
	                this.$emit('response-count');
	            });
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
        },
		autoMatching: async function () {
            await this.api.post(`asks/${this.$route.params.ask_id}/automated`).then((response) => {
				this.loadData();
				this.ask.tags = response.data.tags;
				this.$emit('response-count');
				this.getAsk();
            });
		},
		requestSupportSubmit: async function () {
			console.log("In requestSupportSubmit");
			await this.api
			.post(`asks/${this.ask._id}/request-support`, {supportMessage: this.requestSupportMsg})
			.then(response => {
				console.log("response :", response);
				this.$emit('reload');
				this.reserveStatus = false;
				this.reserveTxt = 'Reserve';
				this.getAsk();
				let checkAdmins = this.community.administrators.some((admin) => admin.escalate == true)
				if (checkAdmins) {
					this.$toast.success('Request Support has been successfully sent.');
				}
				this.requestSupportMsg = '';
				this.showDialog = false;
			});
		},
		coachSubmit: async function () {
			console.log("In coach submit");
			if (this.status !== '(7) Closed') {
				if (this.status != '(8) Rejected') {
					await this.api
					.post(`asks/${this.ask._id}/request/reject`)
					.then(response => {
						this.callCoachFunction('This Request has been rejected and a coaching message was sent to the asker.', true);
					});
				} else {
					this.callCoachFunction('Coaching message was sent to the asker.', true);
				}
			}
			this.coachDialog = false;
		},
		resendEmail: async function (id, email, askId) {
			if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
				this.expandAdviserSection(id);
				let parameter = {advisorId: id, email: email, askId: askId};
				await this.api.post(`asks/${this.$route.params.ask_id}/resend-email`, parameter).then(async response => {
					if (response && response.data && response.data.unsubscribed) {
						this.$toast.error(`Email cannot be sent because the adviser has been unsubscribed`);
					} else {
						await this.updateRecommendedAdvisors();
					}
				});
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		async updateRecommendedAdvisors() {
			await this.api.get(`asks/${this.$route.params.ask_id}/update-recommended-adviser/?isDisplayScore=${this.isDisplayScore}`).then(async advList => {
				this.matchedAdvisors = advList.data.adviserList;
				this.matchedAdvisors = this.$lodash.orderBy(this.matchedAdvisors, ['last_request'], [this.currentMatchedSortLastReqRec]);
				this.$emit("reload");
				this.getAsk();
			});
		},
		reserveClick: async function (status) {
			await this.api.post(`asks/${this.$route.params.ask_id}/update-ownership`, {status: status, askStatus: this.getStatus}).then(async response => {
				if (response.data) {
					this.reserveStatus = response.data.reserve;
					this.reserveTxt = 'Reserve';
					if (response.data.reserve) {
						this.reserveTxt = 'Reserved';
						if (response.data.reserveOwner && response.data.reserveOwner.email) {
							this.ask.reserveOwner = {
								email: response.data.reserveOwner.email
							}
							this.isReserveOwner = true;
						}
					} else {
						this.isReserveOwner = false;
					}
				}
			});
		},
		goToLinkedInProfile: function(link) {
			window.open(link, '_blank');
		},
		selectMatchAdvser: function() {
			if (this.suggestedAdvisorType && this.suggestedAdvisorType != this.selectedMatchAdviser) {
				this.selectedMatchAdviser = this.suggestedAdvisorType;
				this.rematchAdviserSection(this.suggestedAdvisorType);
			}
		},
		folloUpType: function(type, index) {
			for (const [key] of Object.entries(this.followType)) {
				this.isfollowUpMessage[key] = false;
  				if (key != index) {
					delete this.followType[key];
				}
			}
		},
		submitFollowUp: async function (give, index) {
			let isSubmit = true
			if (this.followType[index] == 'no' && !this.followUpMessage[index]) {
				isSubmit = false;
			}
			if (isSubmit) {
				let body = {
					followUp: this.followType[index],
					giveId: give._id
				};
				if (this.followType[index] == 'no') {
					body.message = this.followUpMessage[index];
				}
				await this.api.post(`asks/${this.$route.params.ask_id}/member_follow`, body).then(async response => {
					this.expandResponseSection(give._id.toString());
					await this.getAsk();
				});
			}
		},
		callCoachFunction: async function (toastMsg, callGetAsk = false) {
			await this.api
			.post(`asks/${this.ask._id}/request/coach`, {coachMsg: this.coachMsg})
			.then(response => {
				this.$emit("reload");
				this.reserveStatus = false;
				this.reserveTxt = 'Reserve';
				this.$toast.success(toastMsg, {duration: 5000});
				if (callGetAsk) {
					this.getAsk();
				}
			});
		},
		getAllOwners: async function () {
			await this.api.post(`configuration/get-configuration/protopia-owner`).then(owners => {
        		this.allOwners = owners.data.getData.sort((a, b) => a.email > b.email ? 1 : -1);
			});
		},
    	assignOwner: async function() {
			console.log("Assigning Owner");
			await this.api.post(`asks/${this.ask._id}/assign-owner`, {owner: this.selectedOwner}).then(response => {});
		},
		tinyDate: function (dt) {
			const d = new Date(dt);
			return dt ? `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear() - 2000}` : 'N/A';
		},
		async favoriteRequest(requestId, requestType) {
			const favorite = requestType === 'favorite'
			await this.api.post(`asks/favorite-request`, {askId: requestId, favorite: favorite, requestType: requestType}).then(async (response) => {
                this.$emit("reload");
				this.getAsk();
			});
		}
	}
}
</script>
<style>
.eval-caution {
  background: #FFF8E1;
  color: #7B4F00;
}

.eval-modal .md-dialog-content {
    padding: 20px 24px 24px;
}

.eval-modal .md-dialog-container {
    max-width: 520px;
    width: 90%;
    border-radius: 12px;
    overflow: hidden;
}

.badge-grey {
    background-color: rgba(0, 0, 0, 0.07);
    color: #666;
}

.analysis-section {
	border: 1px solid rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	margin-bottom: 12px;
	overflow: hidden;
	background: white;
}

.analysis-section-header {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 10px 14px;
	background: #f5f5f5;
	font-weight: 600;
	font-size: 14px;
	color: #444;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.analysis-section-header i {
	color: #666;
	font-size: 14px;
}

.analysis-section-body {
	padding: 12px 14px;
}

.analysis-badges-row {
	display: flex;
	gap: 8px;
	margin-bottom: 10px;
	flex-wrap: wrap;
}

.analysis-badge {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	padding: 4px 10px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 600;
}

.badge-green {
	background-color: rgba(46, 125, 50, 0.12);
	color: #2e7d32;
}

.badge-red {
	background-color: rgba(198, 40, 40, 0.12);
	color: #c62828;
}

.badge-yellow {
	background-color: rgba(242, 192, 87, 0.25);
	color: #e65100;
}

.analysis-explanation {
	font-size: 13px;
	color: #555;
	line-height: 1.6;
	margin: 4px 0;
}

.analysis-summary-preview {
	padding: 0 8px;
	margin: 0;
	font-size: 14px;
	line-height: 1.5;
}

.approval-verdict-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    vertical-align: middle;
}

.verdict-approve {
	background-color: rgba(46, 125, 50, 0.15);
	color: #2e7d32;
}

.verdict-caution {
	background-color: rgba(242, 192, 87, 0.25);
	color: #e65100;
}

.verdict-reject {
	background-color: rgba(198, 40, 40, 0.15);
	color: #c62828;
}

.sentiment-chip {
	display: inline-block;
	padding: 3px 10px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 600;
	background-color: rgba(0, 0, 0, 0.07);
	color: #444;
	text-transform: capitalize;
}

.analysis-actions {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 6px;
}

.eval-modal .md-dialog-container {
    max-width: 560px;
    width: 90%;
    border-radius: 12px;
    overflow: hidden;
}

.eval-modal .md-dialog-content {
    padding: 20px 24px;
}

.eval-modal .md-dialog-title {
    padding: 20px 24px 12px;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.eval-modal .md-dialog-actions {
    padding: 12px 24px 16px;
}

.approval-verdict-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin-left: 0;
    margin-bottom: 10px;
    vertical-align: middle;
}

.eval-modal-section {
	margin-bottom: 16px;
}

.eval-modal-label {
	font-size: 11px;
	color: #888;
	text-transform: capitalize;
	margin-bottom: 4px;
	font-weight: 600;
}

.w-30 {
	height: 57px !important;
	align-items: center;
}

.w-30 .md-field {
	min-height: 0;
}

.w-30 .md-field:after {
	display: none;
}

.w-30 .md-field.md-highlight:before {
	display: none;
}

.w-30 .md-field .owner-select {
	padding: 0px 10px !important;
	border: 1px solid #ccc !important;
	border-radius: 4px !important;
	background-color: #fff !important;
}

.w-30 .md-field .owner-select input {
	font-size: 14px !important;
}


.eval-badge {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	border: none;
}

.eval-pass {
	background: #EAF3DE;
	color: #27500A;
}

.eval-fail {
	background: #FCEBEB;
	color: #791F1F;
}

.eval-panel {
	margin-top: 8px;
	border: 0.5px solid #e0e0e0;
	border-radius: 8px;
	padding: 12px 14px;
	background: #f9f9f9;
	font-size: 13px;
}

.eval-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px 16px;
	margin-top: 10px;
}

.eval-score {
	background: #fff;
	border: 0.5px solid #e0e0e0;
	border-radius: 6px;
	padding: 8px 10px;
}

.eval-score-label {
	font-size: 11px;
	color: #888;
	margin-bottom: 2px;
	text-transform: capitalize;
}

.eval-score-val {
	font-size: 15px;
	font-weight: 500;
}

.eval-score-exp {
	font-size: 11px;
	color: #888;
	margin-top: 3px;
	line-height: 1.4;
}

.eval-divider {
	border: none;
	border-top: 0.5px solid #e0e0e0;
	margin: 10px 0;
}

.eval-bias {
	font-size: 12px;
	color: #888;
}

.chevron {
	transition: transform 0.2s;
	display: inline-block;
}

.chevron.open {
	transform: rotate(180deg);
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/RequestDetail.vue